export const journalArticles = [
  {
    id: 1,
    date: {
      en: "12 Apr",
      sr: "12 Apr"
    },
    image: "/journal/article1.png",
    title: {
      en: "Three new scents that completely ruined our plans",
      sr: "Tri nova mirisa koja su nam poremetila planove"
    },
    excerpt: {
      en: "We only wanted to take a quick look. Standard story. No huge expectations, no intention to make a scene. Then three new scents showed up and turned a calm day into a small mess.",
      sr: "Hteli smo samo da bacimo pogled. Standardna priča. Bez velikih očekivanja, bez ikakve namere da pravimo dramu. Onda su se pojavila tri nova mirisa i od mirnog dana napravila mali haos."
    },
    content: {
      en: `There are days when everything goes according to plan. And then there are days when you tell yourself, “Let me just take a quick look and see what’s new.” Well, this was definitely the second kind.

We did not plan to fall for anything. We did not even plan to turn it into a story. We only wanted to check three new fragrances, calmly, over coffee, without hype and without big words. And then the thing happened that always happens when you least expect it — one stops you in your tracks, the second gets under your skin, and the third stays in your head long after you get home.

The first one had that kind of energy that changes the room the moment it appears. It does not shout, it does not perform, but it somehow says, “Alright, I’m here.” Those are the scents you do not explain for too long. You just wear them and let them do their job.

The second one was a completely different story. Calmer, more mature, more like the fragrance that does not demand attention right away, but gets it ten minutes later. Like people who do not walk into a room the loudest, but somehow end up being remembered the most.

And the third... the third was the reason why this tiny “let’s just check what’s new” moment went in a completely different direction. You know that feeling when you cannot explain a scent right away, but you already know you are not going to let it go easily? That one.

That is exactly why we love this part of the story. It is not all about notes, and it is not all about hype either. Sometimes it is just about the moment. About something new showing up and you realizing that it was exactly what had been missing. Those three new scents are arriving to us soon.

And we turned a simple “let’s just see what’s new” into what we always turn it into when a fragrance is good — something personal.

— Charlie`,
      sr: `Postoje dani kada sve ide po planu. I postoje dani kada samo kažeš sebi: “Ajde da bacim pogled, čisto da vidim šta ima novo.” E, ovo je bio taj drugi tip dana.

Nismo planirali da se zaljubimo ni u šta. Nismo planirali ni da pravimo veliku priču. Hteli smo da proverimo tri nova parfema, onako mirno, uz kafu, bez pompe i bez velikih reči. I onda se desilo ono što se često desi kad najmanje očekuješ — jedan te zaustavi, drugi ti se uvuče pod kožu, a treći ti ostane u glavi i kad odeš kući.

Prvi je bio onaj tip mirisa koji odmah unese energiju u prostor. Ne viče, ne glumi, ali kao da samo svojim prisustvom kaže: “Dobro, stigao sam.” Takve parfeme ne objašnjavaš dugo. Samo ih nosiš i pustiš da rade svoje.

Drugi je bio potpuno druga priča. Smireniji, zreliji, više onaj miris koji ne traži pažnju na prvu, ali je dobije posle deset minuta. Kao ljudi koji ne ulaze najglasnije u sobu, ali ih na kraju svi zapamte.

A treći... treći je bio razlog zbog kog je cela ova mala “provera noviteta” otišla u potpuno drugom pravcu. Znate onaj osećaj kad miris ne uspeš da objasniš odmah, ali ti je jasno da nećeš moći da ga pustiš tek tako? E, taj. Zato i volimo ovaj deo priče. Nije sve u notama, nije sve ni u hajpu. Nekad je stvar samo u trenutku. U tome da naiđe nešto novo, a ti shvatiš da ti je baš to falilo.

Ta tri nova mirisa uskoro stižu kod nas. A mi smo od običnog “da vidimo šta ima” opet napravili ono što uvek napravimo kad je miris dobar — lično smo se umešali.

— Čarli`
    },
    relatedProducts: [
      "armaf-club-de-nuit-precieux-i",
      "french-avenue-safari-breeze",
      "lattafa-dynasty"
    ]
  },
  {
    id: 2,
    date: {
      en: "13 Apr",
      sr: "13 Apr"
    },
    image: "/journal/article2.png",
    title: {
      en: "Delivery is now €4, and we handled it like adults. Almost.",
      sr: "Dostava je sada 4€, a mi smo to primili kao odrasli. Skoro."
    },
    excerpt: {
      en: "There comes a moment in every small brand when news arrives that nobody asked for. For us, this time, it came from the courier service. Delivery is no longer €3.5 — it is €4.",
      sr: "Postoji trenutak u svakom malom brendu kad sedne vest koju nisi naručio. Kod nas je ovog puta stigla iz kurirske službe. Dostava više nije 3.5€, nego 4€."
    },
    content: {
      en: `There is a very particular moment when you open a message and, from the first few words alone, you already know you are not going to love what comes next. That is exactly how we found out that delivery went from €3.5 to €4.

It is not a tragedy. It is not the end of the world. It is not even what a normal person would call drama. But it is that small, annoying change that makes you stare at the ceiling for a few seconds, then at a calculator, and then back at the ceiling, just in case the ceiling suddenly has a better solution.

It did not. Still, because we like being clear and fair, it only makes sense to say it plainly: delivery is now €4. And that is exactly the kind of information we never want hidden behind three clicks, tiny print and vague wording. If something changes, we want people to see it immediately. No games, no marketing fog, no moment where you end up paying more than you thought you would.

The good news is that nothing changed in the part that matters more to us than the number itself: we still pack carefully, we still choose what deserves a place on the site, and we still want every package to feel like it was handled properly from start to finish.

Sometimes small costs go up. That does not mean small details are allowed to go down. If we are being honest, €4 is not dream news. But it is real news. And PlayNice should be the kind of place where a guest does not have to guess what changed, what is new, and what to expect. That is exactly why this Journal exists.

To say things normally. Clearly. Like people. And maybe survive one more unnecessary price increase together.

— Charlie`,
      sr: `Postoji onaj poseban trenutak kada otvoriš poruku i već po prvih nekoliko reči znaš da nećeš biti oduševljen. Tako smo i mi saznali da je dostava otišla sa 3.5€ na 4€.

Nije tragedija. Nije smak sveta. Nije čak ni ono što bi normalan čovek nazvao dramom. Ali jeste ta sitna, dosadna promena koja te natera da na kratko pogledaš u plafon, pa u kalkulator, pa opet u plafon, čisto da proveriš da li je plafon možda spreman da ponudi bolje rešenje.

Naravno, nije. Ali pošto volimo da budemo fer i jasni, red je da kažemo kako stvari stoje: dostava je sada 4€. I to je upravo ona vrsta informacije koju niko ne želi da skriva iza tri klika, fusnote i sitnih slova. Ako nešto menjamo, hoćemo da to čovek vidi odmah. Bez glume, bez marketinške magle, bez one priče gde na kraju ispadne da si platio više nego što si mislio.

Dobra vest je da se ništa drugo nije promenilo u onom delu koji je nama važniji od same cifre: i dalje pažljivo pakujemo, i dalje biramo šta ide na sajt, i dalje nam je cilj da čovek kad otvori paket ima osećaj da je dobio nešto što je sređeno kako treba. Nekad mali troškovi porastu, ali to ne znači da mali detalji smeju da padnu.

Ako ćemo iskreno, 4€ nije vest iz snova. Ali je stvarna vest. A PlayNice i treba da bude mesto gde gost ne mora da nagađa šta je novo, šta se promenilo i šta može da očekuje. Zato i postoji ovaj Journal. Da kažemo stvari normalno. Ljudski. I da usput možda zajedno preživimo još po neko “poskupljenje koje nam nije trebalo”.

— Čarli`
    }
  },
  {
    id: 3,
    date: {
      en: "14 Apr",
      sr: "14 Apr"
    },
    image: "/journal/article3.png",
    title: {
      en: "9PM Night Out did not ask for attention. Then it got too much of it.",
      sr: "9PM Night Out nije tražio pažnju. Onda je dobio previše."
    },
    excerpt: {
      en: "Some fragrances arrive quietly. This one did not seem interested in that. It started as an ordinary night out and turned into another reminder that a good scent can stretch a night further than you planned.",
      sr: "Neki parfemi uđu tiho. Ovaj nije baš imao tu nameru. Priča je počela kao običan izlazak, a završila se kao još jedan podsetnik da dobar miris ume da produži noć više nego što si planirao."
    },
    content: {
      en: `There are fragrances you wear because they smell good. And then there are fragrances you wear and somehow the rest of the evening starts writing itself. 9PM Night Out belongs to that second group.

That was not the plan. The plan was simple: a bit of town, a bit of music, one drink, maybe two at most, and then home like a serious person with responsibilities the next day. The moment you hear that sentence, you already know none of it went according to plan.

I wore the fragrance more out of curiosity than calculation. I knew it had energy. I knew it had that evening character that does not belong to the sun, the office or a clean schedule. But I did not expect it to settle into the whole atmosphere that naturally.

At some point I stopped thinking about it at all, and to me that is the best sign. A good fragrance does not need to constantly remind you that it is there. It just has to make heads turn once in a while, catch someone’s attention when you walk by, and make you feel slightly more confident than you were when you left the house.

And the night? The night did what nights do. The music kept getting better as the hours passed. Plans kept falling apart one by one. One drink had long stopped being one drink. Somewhere in between all of that, I realized that 9PM Night Out is exactly what its name promises — a fragrance that does not show up to do the bare minimum, but to become part of the night.

No, we are not going to pretend this turned into a movie and that half the city started chasing me through clubs. But there were looks, questions, and the usual “what are you wearing?” — enough for the fragrance to register a serious win. That is the whole point of a proper night out scent. Not to speak instead of you, but to give you that small edge when you need it.

If you like fragrances with evening energy, confidence and enough character to stay memorable after the music stops, this one deserves your attention. As for everything else, as usual, blame the city.

— Charlie`,
      sr: `Postoje parfemi koje staviš jer ti lepo mirišu. A postoje i oni koje staviš pa se ostatak večeri nekako sam napiše. 9PM Night Out spada u ovu drugu grupu. Nije to bio plan. Plan je bio jednostavan: malo grad, malo muzika, jedno piće, dva maksimalno, i kući kao ozbiljan čovek koji sutra ima obaveze. Već po toj rečenici ti je jasno da se ništa od toga nije desilo kako je zamišljeno.

Parfem sam stavio više iz radoznalosti nego iz kalkulacije. Znao sam da ima energiju. Znao sam da ima taj večernji karakter koji ne traži sunce, kancelariju i uredan raspored. Ali nisam očekivao da će toliko prirodno da legne na celu atmosferu.

U nekom trenutku sam prestao da razmišljam o njemu i to je, po meni, najbolji znak. Dobar parfem ne mora stalno da te podseća da postoji. Dovoljno je da povremeno vrati glave u tvom pravcu, da uhvati nečiju pažnju kada prolaziš i da te natera da i sam sebi deluješ za nijansu sigurnije nego što si bio kad si izlazio iz kuće.

A noć? Pa, noć je uradila svoje. Muzika je postajala sve bolja kako je sat odmicao. Planovi su se raspadali redom. Jedno piće je odavno prestalo da bude jedno piće. A ja sam negde usput shvatio da je 9PM Night Out tačno ono što mu ime obećava — parfem koji ne dolazi da odradi formalnost, nego da bude deo izlaska.

Ne, nećemo sad glumiti film i pričati da me je pola grada jurilo kroz diskoteke. Ali da je bilo pogleda, pitanja i onog standardnog “šta ti je to?”, bilo je. I to sasvim dovoljno da miris upiše sebi jednu ozbiljnu pobedu. To je, uostalom, i poenta dobrog night out parfema. Ne da viče umesto tebe. Nego da ti da onu malu prednost kad ti zatreba.

Ako voliš mirise koji imaju energiju večeri, malo samopouzdanja i dovoljno karaktera da ostanu zapamćeni i kad muzika stane, ovaj zaslužuje tvoju pažnju. A za sve ostalo, kao i obično, kriv je grad.

— Čarli`
    },
    relatedProducts: [
      "afnan-9pm-night-out"
    ]
  },
  {
    id: 4,
    date: {
      en: "17 Apr",
      sr: "17 Apr"
    },
    image: "/journal/article4.png",
    title: {
      en: "I did not fail the day. I just entered it wrong.",
      sr: "Nisam pao dan. Samo sam ušao u njega pogrešno."
    },
    excerpt: {
      en: "Some days do not go wrong because of what happens. They go wrong because of how you show up. I realized that a little too late — and fixed it even later.",
      sr: "Neki dani ne krenu loše zbog onoga što se desi. Krenu loše zbog toga kako uđeš u njih. Ja sam to shvatio malo kasno — a popravio još kasnije."
    },
    content: {
      en: `There are days when nothing works. Not in a dramatic way. Just quietly wrong. You wake up on time but still feel late. Coffee is there, but it does not do its job. Conversations happen, but you are half a second behind them. That was the day. And of course — that was the day something important was waiting for me. Not an exam. Not an interview. But close enough that you know it matters.

I walked in already knowing I was not fully there. Sat down. Nodded. Answered everything correctly. And still — something was missing. At one point, I caught myself thinking about completely irrelevant things. Like why chairs always make noise at the worst possible moment. That is when it clicked. It was not the day. It was me. I entered it wrong.

It sounds small, but it is not — when you get the scent right, you are slightly ahead of everything. When you miss it, you are always catching up. And yes, that morning I missed it. It was not a bad fragrance. It just did not belong there. It was made for slow walks, light air, no pressure. Not for a moment that required presence.

A few hours later, I changed it. No strategy. Just instinct. One spray. Then another. And suddenly… posture returns. Focus returns. You stop explaining yourself too much. It did not fix the day. But it fixed me inside it. And that is usually enough. Most people think fragrance is an extra. It is not. It is the quiet ally that brings you back when you drift a little too far.

—

If you had a day like this, you already understand. If not — you will. Just do not walk into it alone. Arabiyat Prestige Marwa

—

Charlie
Remember. PlayNice.`,
      sr: `Postoje dani kada ništa ne ide. Ne dramatično. Samo — tiho pogrešno. Ustaneš na vreme, ali kasniš. Kafa je tu, ali ne radi posao. Razgovori se vode, ali ti si uvek pola sekunde iza. Takav je bio taj dan. I naravno — baš tada me je čekalo nešto važno. Nije bio prijemni. Nije bio intervju. Ali dovoljno blizu da znaš da ima težinu.

Ušao sam već svestan da nisam skroz tu. Seo. Klimam glavom. Odgovaram tačno. I opet — nešto fali. U jednom trenutku sam uhvatio sebe kako razmišljam o potpuno nebitnim stvarima. Recimo, zašto stolice uvek škripe baš kad treba da ćutiš. I tada mi klikne. Nije bio problem dan. Ja sam pogrešno ušao u njega.

Zvuči sitno, ali nije — kad pogodiš miris, kao da si malo ispred svega. Kad ga promašiš, stalno sustižeš. I da, tog jutra sam ga promašio. Nije bio loš. Samo nije bio za to. Bio je za laganu šetnju, vazduh bez obaveza. Ne za trenutak koji traži prisustvo. Par sati kasnije — promenim ga. Bez plana. Samo refleks. Jedan sprej. Pa drugi.

I odjednom… telo se seti kako treba da stoji. Kako da gleda. Kako da ne objašnjava previše. Nije popravio dan. Ali je popravio mene u tom danu. A to je obično dovoljno. Većina misli da je parfem dodatak. Nije. To je tihi saveznik koji te vrati kad malo odlepiš.

—

Ako si imao ovakav dan — znaš. Ako nisi — imaćeš. Samo nemoj da uđeš u njega sam. Arabiyat Prestige Marwa

—

Čarli
Remember. PlayNice.`
    },
    relatedProducts: [
      "arabiyat-prestige-marwa"
    ]
  },
  {
    id: 5,
    date: {
      en: "18 Apr",
      sr: "18 Apr"
    },
    image: "/journal/article5.png",
    title: {
      en: "Open passage",
      sr: "Otvoren prolaz"
    },
    excerpt: {
      en: "They say the passage is open. On paper, that sounds simple. In real life, the difference between open and truly free is usually where the story begins.",
      sr: "Kažu da je prolaz otvoren. Na papiru, to zvuči jednostavno. U stvarnom životu, razlika između otvorenog i zaista slobodnog je obično mesto gde priča tek počinje."
    },
    content: {
      en: `They say the strait is open. Ships are moving, the world has calmed down a little, and everything looks as if the problem has been solved. At first glance, it sounds simple. The passage exists. You can go through. Just… not exactly like that. It is interesting how these things work. On paper — freedom. In practice — rules.

It reminded me of people. We all like to think we can go wherever we want. Until the moment comes to actually make a move. Then suddenly: “Maybe this is not the right time.” “Maybe this is not smart.” “What will people say…” It is not forbidden. It just is not exactly free. And that is the fine distinction most people miss. Closed doors are not the real problem. At least you can see those.

The problem is the ones that look open — but still make you pause before stepping through. And the world works like that more often than we admit. Passages exist. Rules exist. People move — carefully. In the end, it comes down to one question: Are you moving because you can — or because you were allowed to?

Everyone loves open passages. Until they realize they still have to ask to get through. Alright. That is enough philosophy for today. I’ll just put on a bit of Creed Aventus Cologne, give myself an open passage 👍 and things will probably feel better. That part is at least predictable.

—

Charlie
Remember. PlayNice.`,
      sr: `Kažu da je moreuz otvoren. Brodovi prolaze, svet se malo smirio i sve izgleda kao da je problem rešen. Na prvu, zvuči jednostavno. Prolaz postoji. Može da se prođe. Samo… ne baš tek tako. Zanimljivo je kako te stvari funkcionišu. Na papiru — sloboda. U praksi — pravila. Podsetilo me na ljude. Svi volimo da mislimo da možemo gde hoćemo. Dok ne dođe trenutak da stvarno treba da napravimo korak.

Onda odjednom: “Možda nije pravi trenutak.” “Možda nije pametno.” “Šta će reći…” Nije zabranjeno. Samo nije baš ni slobodno. I to je ona fina razlika koju većina ne primećuje. Nisu zatvorena vrata pravi problem. Njih bar vidiš. Problem su ona koja izgledaju otvoreno — ali te ipak nateraju da zastaneš pre nego što prođeš.

I svet mnogo češće funkcioniše baš tako nego što volimo da priznamo. Prolazi postoje. Pravila postoje. Ljudi prolaze — pažljivo. Na kraju se sve svede na jedno pitanje: Da li ideš jer možeš — ili jer ti je dozvoljeno? Svi vole otvorene prolaze. Dok ne shvate da moraju da pitaju da prođu.

Dobro. Dosta filozofije za danas. Staviću malo Creed Aventus Cologne, dam sebi otvoren prolaz 👍 i biće bolje. To je bar sigurno.

—

Čarli
Remember. PlayNice.`
    },
    relatedProducts: [
      "creed-aventus-cologne"
    ]
  },
  {
    id: 6,
    date: {
      en: "18 Apr",
      sr: "18 Apr"
    },
    image: "/journal/article6.png",
    title: {
      en: "That was not the plan",
      sr: "To nije bio plan"
    },
    excerpt: {
      en: "I went online to look up how to build a birdhouse. A few videos later, I was ordering Rasasi Hawas Ice for more money than I planned. The birdhouse never happened. The fragrance did.",
      sr: "Seo sam da tražim kako se pravi kućica za ptičice. Posle nekoliko videa, naručivao sam Rasasi Hawas Ice za više novca nego što sam planirao. Kućica se nije desila. Parfem jeste."
    },
    content: {
      en: `I was looking up how to build a birdhouse. Seriously.

One of those days when you feel like slowing things down a little. No phone chaos, no noise, just something normal. Wood, a hammer, maybe even some peace. So — YouTube. A video about birdhouses. Then another one. Then another… And then something else. Some guy. Chinese. Confident. Talking about a fragrance like he had just discovered electricity. I did not understand half of it. But I understood enough.

Click. One more video. Then another. And suddenly, I was no longer looking up birdhouses. I was looking for where to buy Rasasi Hawas Ice.

—

The price? Hmm. It was new, a little expensive, and exactly the kind of moment where you stop and tell yourself: “You do not need this.” And then, naturally — you buy it.

—

A few days later, it arrived. I opened it without huge expectations. Honestly, I was more in the mood of: “Alright, let’s see what I’ve done now.” First spray. Pause. Second spray. Ok. This… is not bad at all.

—

It was not one of those dramatic “wow” moments. More like: “Wait a second… this actually makes sense.” It does not shout. It does not push itself forward. But it stays. And people notice.

—

Best part? The birds. I never built them the birdhouse, but they are still circling around mine. Like planes. I think they are going to bomb me. Seriously.

—

And there you go - sometimes you start off looking for one thing… and end up with something completely different. And sometimes - it works out.

—

So if you ask me whether it was worth it? No, I do not have a birdhouse. But I do seem to have a reason they keep coming back. 😉

—

Charlie
Remember. PlayNice.`,
      sr: `Tražio sam kako da napravim kućicu za ptičice. Ozbiljno. Jedan od onih dana kad pomisliš da bi mogao malo da usporiš. Ne telefon, ne haos, nego nešto normalno. Drvo, čekić, možda čak i malo mira. I tako — YouTube. Video o kućicama. Pa još jedan. Pa još jedan… A onda nešto drugo. Neki lik. Kinez. Samouveren. Priča o parfemu kao da je otkrio struju. Ne razumem pola. Ali razumem dovoljno.

Klik. Još jedan video. Pa još jedan. I odjednom — više ne tražim kućicu za ptičice. Tražim gde da kupim Rasasi Hawas Ice.

—

Cena? Hmm. Nov je, košta malo više, i to je baš onaj trenutak kad zastaneš i kažeš sebi: “Ne treba mi ovo.” I onda naravno — kupiš.

—

Par dana kasnije, stiže. Otvaram bez nekog velikog očekivanja. Realno, više sam bio u fazonu: “Dobro, da vidimo šta sam sad uradio.” Prvi sprej. Zastanem. Drugi. Ok. Ovo… nije uopšte loše.

—

Nije to bio onaj dramatični “wow” momenat. Više ono: “Čekaj malo… ovo zapravo ima smisla.” Ne viče. Ne gura se. Ali ostaje. I ljudi počnu da primećuju.

—

Najbolji deo? Ptičice. Kućicu im nikad nisam napravio, ali one i dalje kruže oko moje. Kao avioni. Mislim da će me bombardovati jednog dana. Stvarno.

—

I tako - nekad kreneš po jednu stvar… a završiš na potpuno drugoj. I ponekad - isplati se.

—

I ako me pitaš da li je vredelo? Ne, nemam kućicu za ptičice. Ali izgleda da ipak imam razlog zašto se stalno vraćaju. 😉

—

Čarli
Remember. PlayNice.`
    },
    relatedProducts: [
      "rasasi-hawas-ice"
    ]
  },
  {
    id: 7,
    date: {
      en: "19 Apr",
      sr: "19 Apr"
    },
    image: "/journal/article7.png",
    title: {
      en: "No one knows where they are looking",
      sr: "Niko ne zna gde gleda"
    },
    excerpt: {
      en: "Three people at the same table. Silence. Not awkward, not tense — just… elsewhere. It made me wonder when we all stopped being where we actually are.",
      sr: "Troje ljudi za istim stolom. Tišina. Ne neprijatna, ne napeta — samo… negde drugde. Nateralo me da se zapitam kada smo prestali da budemo tamo gde zapravo jesmo."
    },
    content: {
      en: `I was sitting in a café today and noticed something interesting. Three people at the same table. Quiet. Not awkward, not tense — just… silence. Each one looking at their own phone. Everyone seemed to be somewhere. Just not there. The waiter passed by, lightly bumped into a chair. No one looked up. One guy smiled. Not because something happened at the table — but because something happened somewhere else.

Then I caught myself. Same thing. Phone in hand. Thumb moving. Head… somewhere in between. It is strange how we have all become available to everyone. Except the people sitting right next to us. A few years ago, silence at a table meant something was wrong. Now it feels normal. Almost comfortable. No one asks anything. No one needs attention. Everyone is “busy”.

But that is not really the problem. The problem is that we no longer know where to look when the phone is not in our hands.

—

Maybe that is the only thing worth trying tonight. Not to use your phone less. Just to see what is left when you are not looking at it. If it feels uncomfortable — good. That probably means you are finally there.

—

Charlie
Remember. PlayNice.`,
      sr: `Sedeo sam danas u kafiću i primetio nešto zanimljivo. Za istim stolom — troje ljudi. Tišina. Ne neprijatna, ne napeta — samo… ćute. Svako gleda u svoj telefon. Svi deluju kao da su negde. Ali niko nije tu. Konobar prolazi, nosi piće, malo zakači stolicu. Niko ne podiže pogled. Jedan momak se nasmeje. Ne zato što se nešto desilo tu — nego negde drugde.

I onda uhvatim sebe. Isto. Telefon u ruci. Palac radi. Glava… negde između. Zanimljivo je kako smo postali dostupni svima. Osim onima pored nas. Pre par godina, tišina za stolom je značila da nešto nije u redu. Danas je normalna. Čak i prijatna. Niko te ne pita ništa. Niko ne traži pažnju. Svi su “zauzeti”. Ali to nije pravi problem. Problem je što više ne znamo gde da gledamo kad spustimo telefon.

—

Možda je to jedina stvar koju vredi probati večeras. Ne da manje koristiš telefon. Nego da vidiš šta ostane kad ga ne gledaš. Ako bude neprijatno — dobro. Znači da si konačno tu.

—

Čarli
Remember. PlayNice.`
    },
    relatedProducts: []
  },
  {
    id: 8,
    date: {
      en: "26 Apr",
      sr: "26 Apr"
    },
    image: "/journal/article8.png",
    title: {
      en: "The bus as destiny",
      sr: "Autobus kao sudbina"
    },
    excerpt: {
      en: "I was supposed to travel by motorcycle. Life had other plans. Somehow… it all worked out.",
      sr: "Trebao sam da putujem motorom. Život je imao druge planove. I nekako… sve je ispalo kako treba."
    },
    content: {
      en: `I was supposed to travel by motorcycle, but the motorcycle decided not to be part of this story. The day before the trip something started acting up, nothing serious, but serious enough, and there’s not much philosophy there — the plan falls apart and you look for the next alternative. The bus.

I wasn’t happy about it, but I was stubborn enough to still get somewhere, so I showed up at the station with that face that says “it’ll be fine.” Yeah, right.. I step inside and everything is clear within three seconds… a day at the Nairobi National Park would have been calmer and more organized. And probably with better ventilation.

Anyway, the bus… so beautiful. So colorful. Grandmas with bags who clearly have more travel experience than I have life experience, kids with energy like they just drank three liters of juice, people having phone conversations nobody asked to hear, people who say nothing but take up space, and of course, the driver smoking like it’s part of the equipment.

I sit down, adjust as much as I can. I try to accept the situation without overthinking, but the mind does what it does, and at one point I think how nice it would be if a normal, beautiful girl showed up, just so you have a reason to stand up, move, do something that looks like proper behavior, to at least feel like a normal person in a normal story.

Nothing. The ride goes the way it goes, people do their thing, everyone in their own world, and at some point you realize you stopped getting annoyed, not because it got better, but because you somehow disconnected from the whole situation. You look out the window, thoughts drift, time moves slower than you’d like, but it moves.

When I finally got off, I was tired and slightly overloaded with people, but I wasn’t broken, which honestly surprised me, because everything had the potential to go much worse, and then it hit me… …I had been wearing Boss The Scent Elixir the whole time, without even thinking about it, and it just kept working, and working, and working… because the trip was pretty long and obviously everything felt a lot easier.

And someone said, in the middle of all that chaos: “You smell really good.” And yeah, that’s probably the only reason my mental health wasn’t permanently damaged by this trip. And yeah, a few days later I met an interesting girl. Where I arrived. And yeah, this didn’t turn out that bad after all. 🙂

—

Charlie
Remember. PlayNice.`,
      sr: `Trebao sam da putujem motorom, ali motor je odlučio da ne učestvuje u ovoj priči. Dan pred put počne nešto da zeza, ništa strašno, ali dovoljno ozbiljno, i tu nema puno filozofije — plan se raspadne, a ti tražiš sledeću alternativu. Autobus. Nisam bio srećan zbog toga, ali sam bio uporan da ipak negde stignem, pa sam se pojavio na stanici sa tim izrazom lica koji govori “biće ok”. Daaaa, kako da ne..

Ulazim unutra i sve mi je jasno već posle tri sekunde… dan u Nacionalnom parku Najrobi bi bio mirniji i organizovaniji. I verovatno sa boljom ventilacijom.

Elem, autobus.. tako predivan. Živopisan. Babe sa kesama koje očigledno imaju više iskustva sa putovanjima nego ja sa životom, deca koja imaju energiju kao da su upravo popila tri litre soka, ljudi koji vode telefonske razgovore koje niko nije tražio da čuje, ljudi koji ćute ali zauzimaju prostor, i naravno, šofer koji dimi kao da mu je to dodatna oprema.

Sednem, namestim se koliko mogu. Pokušam da prihvatim situaciju bez previše razmišljanja, ali glava radi svoje i u jednom trenutku pomislim kako bi bilo lepo da se pojavi neka normalna, lepa devojka, čisto da imaš razlog da ustaneš, da se pomeriš, da uradiš nešto što liči na pristojno ponašanje, da se bar malo osećaš kao čovek u normalnoj priči.

Ništa od toga. Put ide kako ide, ljudi rade svoje, svako u svom filmu, i u nekom trenutku shvatiš da si prestao da se nerviraš, ne zato što je postalo bolje, nego zato što si se nekako isključio iz cele te situacije. Gledaš kroz prozor, misli lutaju, vreme prolazi sporije nego što bi želeo, ali ipak prolazi.

Kad sam konačno sišao, bio sam umoran i pomalo zasićen ljudima, ali nisam bio slomljen, što je iskreno bilo malo iznenađenje, jer je sve imalo potencijal da ode mnogo gore, i onda ukapiram… …čitavo sam vreme, i ne razmišljajući o tome, nosio Boss The Scent Elixir, koji je radio, i radio, i radio… jer put je prilično dugačak i očigledno je sve bilo mnogo lakše.

I neko reče, u svom onom haosu: “Baš lepo miriše.” I da, to je verovatno jedini razlog što moje mentalno zdravlje nije trajno oštećeno ovim putovanjem. I da, par dana kasnije sam upoznao jednu interesantnu devojku. Tamo gde sam stigao. I da, sve ovo i nije ispalo tako loše. 🙂

—

Čarli
Remember. PlayNice.`
    },
    relatedProducts: [
      "boss-the-scent-elixir"
    ]
  },
  {
    id: 9,
    date: {
      en: "03 May",
      sr: "03 Maj"
    },
    image: "/journal/article9.png",
    title: {
      en: "Special Edition: Fragrances Tonight",
      sr: "Specijalno izdanje: Mirisi večeras"
    },
    excerpt: {
      en: "Two classics. Different energies. And a few surprises that don’t show up often.",
      sr: "Dva klasika. Dve energije. I nekoliko iznenađenja koja ne dolaze često."
    },
    content: {
      en: `Good evening. This is Charlie, and you’re watching… something that looks like the news, just with better scents and fewer reasons to worry. Tonight we have a short but very clear announcement: new fragrances have arrived. Yes, I know. Take a breath. There’s time for everything.

—

We begin with two main guests. Two classics. Two completely different characters. On the left: Dolce & Gabbana The One A gentleman who enters quietly but never leaves unnoticed. Warm, composed, made for the evening. It doesn’t ask for attention — it simply gets it.

On the right: Versace Man Eau Fraîche The complete opposite. Fresh, clean, light, like a day you didn’t manage to ruin. It doesn’t complicate things — it just works. Two worlds. One decision. Or both, if we’re being honest.

—

But like every good broadcast, this is not all. In the next segment — reinforcement from the East. A group that doesn’t ask for permission. Arabian fragrances with attitude. Louder, bolder, the kind that stay even after you think they’re gone. Not for everyone — and not meant to be.

—

And now, what usually comes at the end, but tonight comes right away — the surprise. A few pieces that don’t show up often. Niche and designer selections that slow you down for a second. Not “just another fragrance” — but a reason to come back and try again.

—

If this sounds like something you should experience in person… it is. Our recommendation is simple: come by, try, don’t decide too early, and bring a good mood. The rest tends to work itself out.

—

This has been a special broadcast. We’re staying here, the fragrances are ready, and you are — if we’re being honest — already halfway here. And remember, because this goes in the lower right corner of the screen: It’s not a problem what you wear… it’s a problem when you wear nothing.

Good night.

—

Charlie
Remember. PlayNice.`,
      sr: `Dobro veče. Ovde Čarli, a vi gledate… pa, nešto što liči na vesti, samo sa mnogo boljim mirisima i znatno manje razloga za brigu. Večeras imamo kratko, ali vrlo konkretno saopštenje: stigli su novi parfemi. Da, znam. Smirite se. Udahnite. Ima vremena za sve.

—

Na početku emisije — dva glavna gosta. Dva klasika. Dva potpuno različita karaktera. Sa leve strane: Dolce & Gabbana The One Gospodin koji ulazi tiho, ali ne izlazi neprimećen. Topao, ozbiljan, večernji tip koji ne traži pažnju, ali je dobija bez pregovora.

Sa desne strane: Versace Man Eau Fraîche Njegov potpuni kontrast. Svež, čist, lagan, kao jutro koje si uspeo da ne pokvariš. Onaj tip koji ne komplikuje stvari — samo radi posao i radi ga dobro. Dva sveta. Jedan izbor. Ili oba, ako si realan čovek.

—

Ali, kao i svaka dobra emisija, ovo nije sve. U nastavku programa — pojačanje sa istoka — dolazi ekipa koja ne pita da li sme. Arapski mirisi sa stavom. Malo glasniji, malo bezobrazniji, oni koji ostanu i kad misliš da su završili. Nisu za svakoga, ali nisu ni napravljeni da budu.

—

I sada, ono što obično ide na kraju, ali večeras ide odmah — iznenađenje. Par komada koji ne dolaze često. Niche i dizajnerski mirisi, oni zbog kojih se ne žuri, nego se zastane. Oni koji nisu “još jedan parfem”, nego razlog da se vratiš i probaš ponovo.

—

Ako sve ovo zvuči kao nešto što bi trebalo da vidiš uživo… to je zato što i jeste. Naša preporuka je jednostavna: dođi, probaj, ne donosi odluke unapred i ponesi dobro raspoloženje. Ostalo će se rešiti samo.

—

Ovo je bilo vanredno uključenje. Mi ostajemo ovde, mirisi su spremni, a ti si — ako ćemo iskreno — već na pola puta. I zapamti, jer ovo ide u donji desni ugao ekrana: Nije problem šta nosiš… problem je kad ništa ne nosiš.

Laku noć.

—

Čarli
Remember. PlayNice.`
    },
    relatedProducts: [
      "dolce-gabbana-the-one-for-men-edt",
      "versace-man-eau-fraiche"
    ]
  },
  {
    id: 10,
    date: {
      en: "10 May",
      sr: "10 Maj"
    },
    image: "/journal/article10.png",
    title: {
      en: "They just have better lighting",
      sr: "Samo imaju bolje osvetljenje"
    },
    excerpt: {
      en: "Maybe the internet didn’t ruin us completely. Maybe it just made ordinary life look less interesting than it really is.",
      sr: "Možda nas internet nije potpuno pokvario. Možda je samo učinio da običan život izgleda manje zanimljivo nego što zapravo jeste."
    },
    content: {
      en: `Honestly. There was a time when people didn’t know what they were missing and were pretty peaceful because of it. Then social media happened. And suddenly everyone is traveling somewhere, everyone has “morning routines”, everyone trains at 6AM, makes coffee from machines that cost as much as a used motorcycle and somehow looks like they’ve never sat on a cold plastic chair outside a corner shop.

Meanwhile, you’re sitting at home, eating delivery food and wondering if it’s normal that you’ve opened the fridge three times today without any actual reason. Of course it is. But online life doesn’t really like this ordinary kind of life.

Online life likes everything to look like a movie scene where the main character completely knows what they’re doing. And realistically… most of us are just improvising well enough not to look completely lost.

—

The worst part is that you slowly start comparing your behind the scenes with someone else’s best moments. Someone is driving a boat through Italy. Someone is meditating in Bali. Someone is “grateful for their journey”. And you’re just trying to survive Monday without a psychological collapse because someone sent: “Hey, can you do this really quickly?”

And you know what? I think we’re all a little tired of everything needing to look perfect.

—

Because nobody posts the moment they sit in the car for five minutes in silence before going home. Nobody uploads the part where they spent 40 minutes deciding what to order and still picked the same thing they’ve been eating for three years. Nobody shares how they typed and deleted the same message five times because they didn’t know how to sound normal.

And honestly, that’s where real life actually happens.

—

And maybe the biggest luxury today is not having to prove anything to anyone. Going for coffee without photographing it. Buying a fragrance because you like it, not because somebody online called it a “must have”. Having a good day even if it’s not content.

—

Of course, we’re all going to keep scrolling. I will. You will. The entire planet will. That battle is already lost. But maybe it would be nice to remember from time to time that people on social media don’t actually live inside those reels. They also turn the camera off. They also sit tired at home, eat something straight from the bag and stare at the ceiling like the rest of civilization.

They just have better lighting.

—

Oh, and by the way… we added 5 new fragrances to the site. There’s some material for your next reel, story or that photo where you thoughtfully stare through the car window while deep house plays in the background. Just doing my part in helping create that “perfect”, worth-living life. You’re welcome.

—

Charlie
Remember. PlayNice.`,
      sr: `Iskreno. Nekad čovek nije znao šta mu fali i bio je prilično miran zbog toga. Onda smo dobili društvene mreže. I odjednom svi negde putuju, svi imaju “jutarnje rutine”, svi treniraju u 6 ujutru, kuvaju kafu iz aparata koji košta kao polovan motor i izgledaju kao da nikad nisu seli mokrom guzicom na hladnu plastičnu stolicu ispred trafike.

A ti sediš kući, jedeš nešto iz dostave i razmišljaš da li je normalno što si danas već treći put otvorio frižider bez ikakvog konkretnog razloga. Naravno da jeste. Ali online život baš ne voli običan život. Online život voli da sve izgleda kao scena iz filma gde glavni lik tačno zna šta radi sa sobom. A realno… većina nas samo improvizuje dovoljno dobro da ne deluje potpuno izgubljeno.

—

Najgore je što počneš nesvesno da porediš svoj “behind the scenes” sa tuđim “best moments”. Neko vozi brod po Italiji. Neko meditira na Baliju. Neko je “zahvalan na svom putovanju”. A ti pokušavaš da preživiš ponedeljak bez psihološkog raspada jer ti je neko poslao: “Aj samo ovo brzo.” I znaš šta? Mislim da smo svi malo umorni od toga da sve mora da izgleda savršeno.

—

Jer niko ne postavlja sliku trenutka kad sedi u kolima pet minuta u tišini pre nego što uđe kući. Niko ne kači kako je proveo 40 minuta gledajući šta da naruči i na kraju uzeo isto što uzima već tri godine. Niko ne objavljuje kako je pet puta napisao poruku i obrisao je jer nije znao kako da zvuči normalno.

A baš se tu dešava pravi život.

—

I iskreno, možda je najveći luksuz danas postalo to da ne moraš nikome ništa da dokazuješ. Da odeš na kafu i ne slikaš je. Da kupiš parfem jer se tebi sviđa, a ne zato što ga je neko nazvao “must have”. Da ti dan bude dobar čak i ako nije “content”.

—

Naravno, svi ćemo nastaviti da skrolujemo. I ja ću. Ti ćeš. Cela planeta će. To je već izgubljena bitka. Ali možda bi bilo lepo da se s vremena na vreme setimo da ljudi sa društvenih mreža ne žive stvarno u tim reelovima. I oni posle ugase kameru, sednu umorni, jedu nešto iz kese i gledaju u plafon kao ostatak civilizacije.

Samo imaju bolje osvetljenje.

—

A da, inače… stiglo je i 5 novih parfema na sajt. Eto malo materijala za reels, story ili onu fotografiju gde zamišljeno gledaš kroz prozor automobila dok ti igra neki deep house u pozadini. Malo i ja da pomognem u kreiranju tog “savršenog”, vrednog življenja života. Nema na čemu.

—

Čarli
Remember. PlayNice.`
    },
    relatedProducts: [
      "emir-voux-zingy",
      "rayhaan-crimson",
      "rasasi-hawas-black",
      "khadlaj-onyx-silver",
      "arabiyat-prestige-fahad-gaze"
    ]
  },
  {
    id: 11,
    date: {
      en: "21 May",
      sr: "21 Maj"
    },
    image: "/journal/article11.png",
    title: {
      en: "Doctors",
      sr: "Doktori"
    },
    excerpt: {
      en: "Some people make movies. Some people make culture. Key & Peele somehow managed to do both.",
      sr: "Neki ljudi prave filmove. Neki ljudi prave kulturu. Key & Peele su nekako uspeli da urade oba."
    },
    content: {
      en: `There are actors you like. And then there are the ones you respect because they’re big, serious, Oscar-level beautiful people with perfect lighting and agents that probably cost as much as a small shopping mall.

And somewhere off to the side stand Keegan-Michael Key and Jordan Peele, two guys who built a bigger cultural legacy through sketches about complete nonsense than half of Hollywood with 200-million-dollar budgets.

And I genuinely think people don’t realize how massive that is, because it’s not easy to create something that stays. The internet is full of content that lasts shorter than yogurt. You watch something. Maybe laugh. Forget it three minutes later. And then these two write a sketch about a substitute teacher mispronouncing names and civilization is still saying: “A-A-Ron.” Ten years later.

That’s no longer comedy, that’s modern cultural archaeology, those are the moments where you imagine that 200 years from now some historian will find a hard drive and conclude: “Yes… this was obviously a very important tribe.” And honestly? They’d be completely right.

—

Because Key and Peele aren’t just funny. They have that rare superpower of taking something completely ordinary and turning it into a universal story about ego, insecurity, pretending, society, men trying to act tougher than they really are and people desperately trying to look cool while emotionally collapsing inside. And they package all of it in a way that makes you choke from laughing.

That’s a doctorate. Not internet “genius”. Not “content creator”. A doctorate.

—

I mean, we already have a few doctors. We have Valentino Rossi, we have Gregory House… and honestly, just look at John Travolta these days.. DOCTOR. And then you have two more: Key & Peele. Doctors of human behavior. Doctors of absurdity. Doctors of life.

—

The other day I rewatched Keanu and kept thinking how unbelievable it is that they managed to make an action movie about a kitten… and somehow make it genuinely good. Not “funny sometimes”, actually good. That’s serious talent. That’s the level where you stop understanding how someone’s brain even works. And honestly… what a privilege it is to belong to the generation watching all of this while it’s happening.

Because one day people will talk about them the same way we talk about legendary comedy duos, except these two will have an extra layer: they survived the internet era and stayed relevant without selling their souls to the algorithm. That’s almost superhuman.

—

And honestly, I only want one thing from them: Please… just keep going. Make anything. A sketch about parking.

A movie about a mailman. A series about a guy buying watermelon. Doesn’t matter. Because when minds like that work together, it makes you feel like culture maybe hasn’t completely collapsed yet.

And that’s a really beautiful feeling.

—

Bravo, doctors.

—

Charlie
Remember. PlayNice.`,
      sr: `Postoje glumci koje voliš. Postoje i oni koje poštuješ jer su veliki, ozbiljni, oskarovski, lepi ljudi sa savršenim osvetljenjem i agentima koji verovatno koštaju kao manji tržni centar. I onda negde sa strane stoje Keegan-Michael Key i Jordan Peele, dvojica ljudi koji su napravili veću kulturnu zaostavštinu kroz skečeve o potpunim glupostima nego pola Holivuda kroz budžete od 200 miliona dolara.

I stvarno mislim da ljudi nisu svesni koliko je to veliko, jer nije lako napraviti nešto što ostane. Internet je pun sadržaja koji traje kraće od jogurta. Pogledaš nešto. Nasmeješ se možda. Zaboraviš za tri minuta. A onda ova dvojica napišu skeč o nastavniku koji pogrešno izgovara imena i civilizacija deset godina kasnije i dalje govori: “A-A-Ron.”

To više nije humor, to je arheologija moderne kulture, to su oni trenuci gde pomisliš da će za 200 godina neki istoričar pronaći hard disk i zaključiti: “Da… ovo je očigledno bilo veoma važno pleme.” I iskreno? Biće potpuno u pravu.

—

Jer Key i Peele nisu samo smešni. Oni imaju onu retku supermoć da uzmu nešto potpuno banalno i pretvore ga u univerzalnu ljudsku priču o egu, nesigurnosti, glumi, društvu, muškarcima koji pokušavaju da deluju opasnije nego što jesu i ljudima koji očajnički žele da izgledaju cool dok se raspadaju iznutra. I sve to upakuju tako da se ti bukvalno gušiš od smeha.

To je doktorat. Ne internet “genije”. Ne “content creator”. Doktorat.

—

Mislim, imamo mi već par doktora, imamo Valentina Rosija, imamo i Gregori Hausa, šta tek reći za današnji izgled Džon Travolte.. DOKTOR. I onda imaš još dvojicu vrhunskih: Key & Peele. Doktore za ljudsko ponašanje. Doktore za apsurd. Doktore za život.

—

Pre neki dan sam opet gledao Keanu i razmišljao kako je potpuno neverovatno da su uspeli da naprave akcioni film oko mačeta… i da bude dobar. Ne “smešan na momente”, nego stvarno dobar. To je ozbiljan talenat. To je onaj nivo kada više ni ne razumeš kako nekome mozak radi. I uh… kakva je privilegija biti deo generacije koja gleda sve to dok nastaje. Ozbiljno.

Jer jednog dana će ljudi pričati o njima kao što danas pričamo o legendarnim komičarskim dvojcima, samo što će ovi imati dodatni sloj: uspeli su da prežive internet eru i da ostanu relevantni bez prodavanja duše algoritmu. To je skoro nadljudska sposobnost.

—

I zato imam samo jednu želju kad su njih dvojica u pitanju: Brate… samo nastavite. Snimajte bilo šta. Skeč o parkingu.

Film o poštaru. Seriju o čoveku koji kupuje lubenicu. Nije bitno. Jer kad dve takve glave rade zajedno, čovek nekako ima osećaj da kultura još uvek nije potpuno propala.

I to je baš lep osećaj.

—

Bravo, doktori.

—

Čarli
Remember. PlayNice.`
    },
    relatedProducts: [
      "afnan-supremacy-collectors-edition"
    ],
    links: [
      {
        label: {
          en: "Key & Peele — Substitute Teacher",
          sr: "Key & Peele — Substitute Teacher"
        },
        url: "https://www.youtube.com/watch?v=Dd7FixvoKBw",
        external: true
      },
      {
        label: {
          en: "Keanu (2016) — IMDb",
          sr: "Keanu (2016) — IMDb"
        },
        url: "https://www.imdb.com/title/tt4139124/",
        external: true
      }
    ]
  },
  {
    id: 12,
    date: {
      en: "25 May",
      sr: "25 Maj"
    },
    image: "/journal/article12.png",
    title: {
      en: "When you’re living your best life",
      sr: "Ono kad živiš svoj najbolji život"
    },
    excerpt: {
      en: "Some nights stay with you forever. Not because of what happened, but because of how alive you felt while it was happening.",
      sr: "Neke noći ostanu sa tobom zauvek. Ne zbog onoga što se desilo, nego zbog toga koliko si se živo osećao dok se dešavalo."
    },
    content: {
      en: `I don’t know if this was the best night of my life… but so far — very possible.

It was one of those evenings where you feel something big is coming. Not drama. Just that rare warm energy when the city somehow looks better than usual, music in the distance sounds promising… and you’re already moving slightly to the rhythm, and for the first time in a while you’re not thinking about work, responsibilities or any of the random nonsense life throws at you.

Just stress free, baby. That night, I genuinely expected a great night out.

—

And somehow, everything was perfectly aligned. The club was packed, but not with that exhausting crowd where everyone is pretending to be someone else. This was real nightlife. Incredible music. Loud enough that serious conversation became impossible, but good enough that nobody even wanted serious conversation.

A drink at the bar. Then another one. Then that dangerous confidence a man gets somewhere between the second song and the third whiskey when he suddenly thinks: “Damn… I actually look good tonight.” And honestly… maybe the worst part is that I was completely right.

I was fully ready for a dangerously good night.

—

Around two in the morning, the two of them appeared. A blonde and a brunette. Good Lord. The blonde had the kind of smile that makes you instantly forget what you were about to say, while the brunette had that look that says she knows exactly what she wants and exactly how much trouble she could cause… and she’s perfectly calm about it.

Some women look beautiful. Others bring atmosphere with them. They walked into the club like they owned the night. And honestly, nobody disagreed.

—

At some point we ended up at the bar together, and eventually we weren’t really “at” the bar anymore as much as around it, on it, beside it, while the music somehow kept getting better as the night moved forward. And that’s what people forget about truly good nights out. You don’t remember the exact songs. You don’t remember how much you drank.

You remember the energy. You remember how you felt. You remember that exact moment when you look around and think: “Damn… life can actually be unbelievably good.”

—

We ended up back at my place, that much I know. I also remember my neighbor yelling something at four in the morning, but… honestly, who cares. At that moment I was living my best life and I didn’t want it to end. A lot of that night stayed blurry. But those two fragrances?

I never forgot them. Hers. And hers. One warm, soft and dangerous enough to make a man take a terrible decision without a second of regret.

The other colder, cleaner, but with that kind of confidence that makes you move closer even when you know perfectly well you won’t walk away completely calm from the whole story. And maybe that’s the most beautiful thing about great fragrances. Years pass. People leave.

Cities change. But certain scents stay locked somewhere inside your memory like a private time machine waiting to take you back to moments you never really wanted to leave.

—

What a night. What fragrances. Thank you, life.

—

Charlie
Remember. PlayNice.`,
      sr: `Ne znam da li je ovo bio najbolji izlazak u mom životu… ali do sada — vrlo moguće.

To je jedan od onih dana, tačnije večeri, kad osećaš da se nešto veliko sprema. Ne drama. Samo ona neka retko predivna i topla energija kada i grad izgleda lepše nego inače, muzika negde u daljini zvuči obećavajuće… i već lagano igraš u ritmu, i prvi put posle dužeg vremena ne razmišljaš niti o poslu, niti o obavezama… jednostavno stress free bejbi.

Te večeri sam stvarno očekivao dobar izlazak.

—

I sve je nekako bilo namešteno kako treba. Diskoteka je bila prepuna, ali ne ona naporna gužva gde svi nešto glumataju, nego prava noćna atmosfera. Muzika brutalna. Dovoljno glasna da ne možeš da vodiš ozbiljan razgovor, a opet taman toliko dobra da ti ni ne treba razgovor. Piće za šankom. Pa još jedno.

Pa ono opasno samopouzdanje koje čovek dobije negde između druge pesme i trećeg viskija kad pomisli: “Stvarno večeras izgledam dobro.” Baš sam bio raspoložen za problematično dobru noć.

—

Negde oko dva ujutru pojavile su se njih dve. Plavuša i crnka. Bože dragi. Plavuša je imala onaj osmeh zbog kog potpuno zaboraviš šta si hteo da kažeš, a crnka pogled koji izgleda kao da tačno zna šta želi i koliko problema može da ti napravi, i potpuno je mirna zbog toga.

Postoje žene koje lepo izgledaju. A postoje i one koje donesu atmosferu sa sobom. Ušle su u klub kao da su vlasnice noći. I ne, niko se nije bunio.

—

U nekom trenutku završili smo za šankom zajedno, pa onda više nismo bili baš “za” šankom koliko… oko njega, na njemu, pored njega, uz muziku koja je postajala sve bolja što je noć više odmicala. I to je ono što ljudi zaboravljaju o dobrim izlascima. Ne pamtiš tačno pesme. Ne pamtiš ni koliko si popio.

Pamtiš energiju. Pamtiš kako si se osećao. Pamtiš trenutak kada pogledaš oko sebe i pomisliš: “Vau… život stvarno ume da bude brutalno dobar.”

—

Bili smo kod mene, to znam. Sećam se i da mi je komšinica nešto dobacivala u četiri ujutro, ali… hej, koga briga. Trenutno živim svoj najbolji život i ne želim da završi. Dosta toga iz te večeri mi je ostalo mutno. Ali ta dva mirisa nikad nisam zaboravio. Njen.

I njen. Jedan topao, mekan i opasan taman toliko da čovek napravi lošu odluku bez trunke kajanja. Drugi hladniji, čistiji, ali sa onom vrstom samopouzdanja koja te natera da priđeš bliže iako vrlo dobro znaš da nećeš izaći potpuno miran iz cele priče. I možda je baš to najlepše kod dobrih mirisa.

Godine prođu. Ljudi odu. Gradovi se promene. Ali neki mirisi ostanu zaključani negde u glavi kao privatna vremenska mašina za sve te predivne uspomene koje samo čekaju da ih ponovo posetiš.

—

Kakva noć. Kakvi mirisi. Hvala ti, živote.

—

Čarli
Remember. PlayNice.`
    },
    relatedProducts: [
      "narciso-rodriguez-poudree",
      "ysl-black-opium-le-parfum"
    ]
  },
  {
    id: 13,
    date: {
      en: "06 Jun",
      sr: "06 Jun"
    },
    image: "/journal/community-most-wanted-drop-01.jpg",
    series: {
      en: "COMMUNITY SERIES",
      sr: "SERIJAL ZAJEDNICE"
    },
    title: {
      en: "You asked. We listened.",
      sr: "Tražili ste. Poslušali smo."
    },
    excerpt: {
      en: "Valentino Coral Fantasy and YSL Y Iced joined the collection because the community asked. Prada Paradigme is currently leading.",
      sr: "Valentino Coral Fantasy i YSL Y Iced stigli su jer ih je zajednica tražila. Sledeći na listi vodi Prada Paradigme."
    },
    content: {
      en: `Some of the best additions to our collection did not start with a big marketing plan. They started with one message, then another, then ten more.

Over the past months, we received many suggestions, messages and requests about fragrances you wanted to see in the PlayNice collection. Two names clearly stood out:
Valentino Uomo Born In Roma Coral Fantasy — 16 community requests
Yves Saint Laurent Y Iced Cologne — 27 community requests

And that is why they are now part of our collection. Not because they are everywhere. Not because everyone is selling them. But because you asked for them.

---

PlayNice was never meant to be a random catalogue with hundreds of fragrances. We want a collection that makes sense — a collection our community actually wants to wear, explore and recommend. That is why we read every request.

Some scents we manage to find quickly. Some take more time. And some surprise us with the number of votes they receive.

---

If you follow the request section on our site, you have probably already noticed the next name appearing again and again: Prada Paradigme. And if everything goes as planned, it could very soon become the next member of the PlayNice collection.

---

COMMUNITY MOST WANTED LEADERBOARD
🥇 Yves Saint Laurent Y Iced Cologne — 27 requests ✓ Added
🥈 Valentino Uomo Born In Roma Coral Fantasy — 16 requests ✓ Added
🥉 Prada Paradigme — Currently leading ⏳

---

Maybe your suggestion is the next fragrance we add. So keep voting, requesting and sharing your favorites. Because some of our best drops did not start in the office. They started in the messages from our community.

You asked. We listened.

Remember. PlayNice.`,
      sr: `Neki od najboljih dodataka kolekciji nisu počeli velikim marketinškim planom. Počeli su jednom porukom, pa još jednom, pa još deset njih.

Tokom poslednjih meseci primili smo veliki broj predloga, poruka i pitanja o parfemima koje biste voleli da vidite u PlayNice kolekciji. Dva imena su se posebno izdvojila:
Valentino Uomo Born In Roma Coral Fantasy — 16 zahteva zajednice
Yves Saint Laurent Y Iced Cologne — 27 zahteva zajednice

I zato su danas deo naše kolekcije. Ne zato što su trenutno popularni. Ne zato što ih svi prodaju. Već zato što ste ih upravo vi tražili.

---

PlayNice nikada nije zamišljen kao katalog sa stotinama nasumično dodatih parfema. Želimo kolekciju koja ima smisla — kolekciju koju zajednica zaista želi da nosi, istražuje i preporučuje. Zbog toga svaki zahtev čitamo.

Neke mirise uspemo da pronađemo odmah. Neki zahtevaju više vremena. A neki nas iznenade brojem glasova koje dobiju.

---

Ako pratite sekciju za zahteve na sajtu, verovatno ste već primetili sledeće ime koje se stalno pojavljuje: Prada Paradigme. I ako sve bude po planu, mogao bi vrlo uskoro da postane sledeći član PlayNice kolekcije.

---

NAJTRAŽENIJI MIRISI ZAJEDNICE
🥇 Yves Saint Laurent Y Iced Cologne — 27 zahteva ✓ Dodato
🥈 Valentino Uomo Born In Roma Coral Fantasy — 16 zahteva ✓ Dodato
🥉 Prada Paradigme — Trenutno vodi ⏳

---

Možda je upravo vaš predlog sledeći parfem koji ćemo dodati. Zato nastavite da glasate, predlažete i delite svoje favorite. Jer neki od naših najboljih dropova nisu počeli u kancelariji. Počeli su u porukama naše zajednice.

Tražili ste. Poslušali smo.

Remember. PlayNice.`
    },
    links: [
      {
        label: {
          en: "Request the next scent",
          sr: "Predloži sledeći parfem"
        },
        action: "scent-request"
      }
    ],
    relatedProducts: [
      "valentino-uomo-born-in-roma-coral-fantasy",
      "ysl-y-iced-cologne"
    ]
  },
  {
    id: 14,
    date: {
      en: "25 Jun",
      sr: "25 Jun"
    },
    image: "/journal/community-most-wanted-drop-02.jpg",
    series: {
      en: "COMMUNITY SERIES",
      sr: "SERIJAL ZAJEDNICE"
    },
    title: {
      en: "Votes become collection.",
      sr: "Glasovi postaju kolekcija."
    },
    excerpt: {
      en: "Prada Paradigme and Bad Boy Cobalt are the newest community picks to join the PlayNice collection.",
      sr: "Prada Paradigme i Bad Boy Cobalt postali su novi članovi PlayNice kolekcije zahvaljujući glasovima zajednice."
    },
    content: {
      en: `Some thought Valentino Coral Fantasy and YSL Y Iced Cologne were a one-time story. They were not. They were only the beginning. From day one, we promised to build this collection together with the community.

Today we can welcome two more fragrances that arrived for one simple reason: you asked for them.

---

Prada Paradigme Eau de Parfum — now part of the PlayNice collection
Carolina Herrera Bad Boy Cobalt Eau de Parfum — now part of the PlayNice collection

---

If you keep an eye on the Community Requests section, you already know how quickly things change. Votes grow. New names appear. Some stay around for weeks, some suddenly climb to the top, and some eventually become reality.

That is how the PlayNice collection grows: not by adding random bottles, but by listening to the people who actually wear them.

---

A few weeks ago there were only two community winners. Today there are already four. That may be the clearest proof that the system works. Every vote leaves a mark, and every request has a chance to become the next drop.

---

COMMUNITY SERIES
✓ Yves Saint Laurent Y Iced Cologne
✓ Valentino Uomo Born In Roma Coral Fantasy
✓ Prada Paradigme Eau de Parfum
✓ Carolina Herrera Bad Boy Cobalt Eau de Parfum

---

And the story is far from over. New names are already climbing the leaderboard. Maybe the next article will be about the fragrance you voted for. Because the best ideas still don't start in meetings. They start with our community.

Remember. PlayNice.`,
      sr: `Neki su mislili da su Valentino Coral Fantasy i YSL Y Iced Cologne bili izuzetak. Nisu. Bili su tek početak. Od prvog dana obećali smo da ćemo ovu kolekciju graditi zajedno sa zajednicom.

Danas možemo da poželimo dobrodošlicu još dva mirisa koja su stigla iz jednog jednostavnog razloga: tražili ste ih.

---

Prada Paradigme Eau de Parfum — novi član PlayNice kolekcije
Carolina Herrera Bad Boy Cobalt Eau de Parfum — novi član PlayNice kolekcije

---

Ako pratite Community Requests sekciju, već znate koliko brzo stvari mogu da se promene. Glasovi rastu. Nova imena se pojavljuju. Neka ostanu nedeljama, neka iznenada preuzmu vrh liste, a neka na kraju postanu stvarnost.

Tako raste PlayNice kolekcija: ne dodavanjem nasumičnih bočica, već slušanjem ljudi koji će te parfeme zaista nositi.

---

Pre samo nekoliko sedmica imali smo dva pobednika zajednice. Danas ih već imamo četiri. To je možda najbolji dokaz da ovaj sistem funkcioniše. Svaki glas ostavlja trag, a svaki zahtev ima priliku da postane sledeći drop.

---

COMMUNITY SERIES
✓ Yves Saint Laurent Y Iced Cologne
✓ Valentino Uomo Born In Roma Coral Fantasy
✓ Prada Paradigme Eau de Parfum
✓ Carolina Herrera Bad Boy Cobalt Eau de Parfum

---

A priča se ovde ne završava. Nova imena već polako osvajaju vrh liste. Možda će sledeći članak biti upravo o parfemu za koji ste vi prvi glasali. Jer najbolje ideje i dalje ne nastaju na sastancima. Nastaju u našoj zajednici.

Remember. PlayNice.`
    },
    links: [
      {
        label: {
          en: "Request the next scent",
          sr: "Predloži sledeći parfem"
        },
        action: "scent-request"
      }
    ],
    relatedProducts: [
      "prada-paradigme-edp",
      "carolina-herrera-bad-boy-cobalt-edp"
    ]
  },
  {
    id: 15,
    date: {
      en: "26 Jun",
      sr: "26 Jun"
    },
    image: "/journal/four-new-signatures.jpg",
    series: {
      en: "PLAYNICE SELECTION",
      sr: "PLAYNICE SELECTION"
    },
    title: {
      en: "Four new signatures.",
      sr: "Četiri nova potpisa."
    },
    excerpt: {
      en: "Four carefully selected fragrances. Four completely different personalities. One philosophy — never add bottles just to fill the shelf.",
      sr: "Četiri pažljivo odabrana parfema. Četiri potpuno različita karaktera. Jedna filozofija — ne dodajemo bočice da bismo popunili policu."
    },
    content: {
      en: `Some collections grow by numbers. Ours grows by decisions.

Every fragrance we add has to deserve its place — not because it is trending, but because it offers something unique. This month, four very different signatures joined PlayNice.

Bvlgari Man In Black Eau de Parfum

Warm. Elegant. Confident. A fragrance made for evenings, formal occasions and moments when presence matters more than volume.

Mancera Aoud Lemon Mint Eau de Parfum

Fresh citrus. Dark woods. Unexpected depth. One of those rare fragrances that feels energetic while remaining unmistakably niche.

Yves Saint Laurent MYSLF Eau de Parfum

Modern. Clean. Versatile. The kind of fragrance that effortlessly moves from office mornings to late dinners without ever feeling out of place.

Prada Luna Rossa Ocean Eau de Toilette

Fresh air. Blue elegance. Everyday confidence. Comfortable enough for daily wear, refined enough to become someone's signature scent.

Different seasons. Different personalities. Different occasions. The same reason they were selected: they bring something our collection didn't have yesterday.

That is how PlayNice grows. Slowly. Carefully. Intentionally. We believe discovering a fragrance should feel exciting, not overwhelming. That is why we continue building a collection where every bottle earns its place.

Try them. Wear them. Find the one that feels like yours.

Remember. PlayNice.`,
      sr: `Neke kolekcije rastu brojem parfema. Naša raste odlukama.

Svaki miris koji dodamo mora da zasluži svoje mesto — ne zato što je trenutno popularan, već zato što donosi nešto posebno. Ovog puta u PlayNice stižu četiri potpuno različita karaktera.

Bvlgari Man In Black Eau de Parfum

Topao. Elegantan. Samouveren. Parfem za večeri, posebne prilike i trenutke kada prisustvo govori više od glasnih reči.

Mancera Aoud Lemon Mint Eau de Parfum

Eksplozija citrusa. Dubina drveta i ouda. Neočekivana svežina. Jedan od onih niche parfema koji uspeva da bude energičan, a potpuno drugačiji od svega što ga okružuje.

Yves Saint Laurent MYSLF Eau de Parfum

Moderan. Čist. Svestran. Podjednako prirodan uz jutarnju kafu, poslovni sastanak ili večernji izlazak. Jedan parfem. Bezbroj prilika.

Prada Luna Rossa Ocean Eau de Toilette

Miris svežeg vazduha. Plava elegancija. Samopouzdanje bez napora. Parfem koji lako može postati nečiji svakodnevni potpis.

Četiri godišnja doba. Četiri različite ličnosti. Četiri potpuno različita razloga da ih nosite. Ali jedan razlog zbog kojeg su danas deo PlayNice kolekcije: pažljivo su odabrani.

U PlayNice ne jurimo broj parfema. Gradimo kolekciju u kojoj svaka bočica ima svoje mesto. Zato istražujemo, probamo i upoređujemo. Biramo samo ono iza čega možemo da stanemo.

Ako još nisi pronašao svoj sledeći omiljeni miris, možda se upravo nalazi među ova četiri nova potpisa.

Remember. PlayNice.`
    },
    links: [
      {
        label: {
          en: "Explore the collection",
          sr: "Istraži kolekciju"
        },
        action: "shop"
      }
    ],
    relatedProducts: [
      "bvlgari-man-in-black-edp",
      "mancera-aoud-lemon-mint",
      "ysl-myslf-edp",
      "prada-luna-rossa-ocean-edt"
    ]
  },
  {
    id: 16,
    date: {
      en: "09 Jul",
      sr: "09 Jul"
    },
    image: "/journal/thomas-kosmala-le-sel-de-la-terre.jpg",
    title: {
      en: "How do you create a man who smells like this?",
      sr: "Kako se pravi čovek koji miriše ovako?"
    },
    excerpt: {
      en: "Sometimes a fragrance tells you more about its creator than any biography ever could. This is not a story about perfume. It's a story about the man behind it.",
      sr: "Ponekad ti jedan parfem kaže više o svom autoru nego bilo koja biografija. Ovo nije priča o parfemu. Ovo je priča o čoveku koji ga je stvorio."
    },
    content: {
      en: `Sometimes I pick up a fragrance and completely forget about the fragrance itself. Instead, I start thinking about the person who created it. That's exactly what happened with Le Sel de la Terre. I found myself staring at the bottle, trying to imagine what Thomas Kosmala's journey really looked like. Not the official version that fits into a few lines of biography, but the real one. The one nobody ever writes about.

In my head, it always starts like a film. One day, a young man from Poland packs a suitcase and heads to France. Not because it would be easier there, but because it wouldn't. Instead of choosing the shortest road, he chooses the slowest one. He spends years learning perfumery directly from a master perfumer, one-on-one, without shortcuts, without glamour, without trying to rush the process.

That alone already tells me something about his character. Today everyone wants to master something in three months. Apparently, Thomas had a different plan.

The next scene takes us to the south of France, where he opens his own laboratory and begins creating what the world now knows as Thomas Kosmala fragrances. It sounds simple when you write it in one sentence, but I have a feeling there are ten invisible years hidden between those two moments.

I imagine him unlocking the lab early in the morning. Bottles everywhere. Formulas. Notes covered with corrections. Mixing, testing, smelling, starting over again. Then silence. He puts the bottle down and quietly says: "Not yet." Not once.

Probably hundreds of times. That's the part of the story that fascinates me far more than success itself. I don't know what music he listens to while he works. I don't know if he drinks espresso or tea.

I don't know if he ever forgets his keys or gets annoyed when the internet freezes at exactly the wrong moment. And honestly... I'm glad I don't know. Maybe that's why I enjoy leaving room for imagination. Whenever there's a little empty space, the mind starts filling it with stories. I like believing that people who create extraordinary things still live wonderfully ordinary lives.

Maybe that's why his fragrances feel different. They don't seem desperate to impress anyone. They don't shout. They don't ask for attention.

They simply exist with quiet confidence. I've always admired people like that. The first time I smelled Le Sel de la Terre, I didn't think: "What an incredible fragrance."

Instead I thought: "Who on earth is the man who imagined this?" That doesn't happen very often. Usually you discover a perfume through its notes. This time, I wanted to discover its creator.

If I ever have the chance to sit down with Thomas Kosmala over a cup of coffee, I probably won't ask him how he made Le Sel de la Terre. Thousands of people have probably asked him that already. I'd ask him something much simpler. "How many times did you almost give up... and how many times did you quietly say: 'Not yet'?"

For some reason, I have a feeling the answer smells even better than the fragrance itself.

—
Charlie
Remember. PlayNice.`,
      sr: `Ponekad uzmem neki parfem u ruku i potpuno zaboravim da razmišljam o parfemu. Počnem da razmišljam o čoveku koji ga je napravio. Tako je bilo i sa Le Sel de la Terre. Gledam bočicu i pokušavam da zamislim kako je uopšte izgledao put Thomasa Kosmale do tog trenutka. Ne onaj zvanični, koji stane u nekoliko redova biografije, nego onaj pravi. Onaj koji se nikad ne piše.

U mojoj glavi to uvek počne kao film. Jednog dana jedan mladić iz Poljske spakuje kofer i krene put Francuske. Ne zato što je tamo lakše, nego upravo zato što nije. Umesto da bira najkraći put, bira najsporiji. Godinama uči parfimerstvo direktno od jednog učitelja, jedan na jedan, bez velike škole, bez pompe i bez prečica. Samo čovek, zanat i vreme.

Već tu mi postane zanimljiv. Danas svi žele da nauče sve za tri meseca. On je očigledno imao drugačiji plan. Posle dolazi sledeća scena. Negde na jugu Francuske otvara svoju laboratoriju i počinje da radi ono zbog čega ga danas poznajemo. To zvuči jednostavno kada pročitaš u jednoj rečenici, ali imam osećaj da između te dve tačke postoji deset godina koje niko nikada neće moći da ispriča kako treba.

Zamišljam ga kako rano ujutru otključava laboratoriju. Na stolu su bočice, formule, papir pun ispravki. Meša, zapisuje, vraća se nekoliko koraka unazad, ponovo pokušava. Pomiriše. Ćuti. Onda samo odloži bočicu i kaže: "Ne... još nije to." Ne jednom. Nego verovatno stotinama puta. I upravo taj deo priče me fascinira mnogo više od samog uspeha.

Ne znam kakvu muziku sluša dok radi. Ne znam da li pije espresso ili čaj. Ne znam da li kasni na sastanke, zaboravlja ključeve ili se iznervira kada mu internet uspori baš onda kada traži novu ideju. I iskreno... drago mi je što to ne znam.

Možda baš zato i volim da ne znam sve o ljudima. Čim ostane malo praznog prostora, mašta odmah krene da radi svoje. Volim da verujem da ljudi koji naprave nešto veliko i dalje vode sasvim običan život. Da odu po hleb, zaborave gde su parkirali auto i da ponekad sede ispred formule sat vremena, potpuno nemoćni, jer znaju da su blizu, ali još uvek nisu stigli tamo gde žele.

Možda baš zato njegovi parfemi deluju drugačije. Nemam osećaj da pokušavaju da mi se svide. Ne guraju se. Ne viču.

Ne mole za pažnju. Ponašaju se kao ljudi koji odavno više nemaju potrebu da bilo kome dokazuju ko su. A takvi ljudi su mi oduvek bili najzanimljiviji.

Kad sam prvi put pomirisao Le Sel de la Terre, nisam pomislio: "Kako dobar parfem." Pomislio sam: "Ko je, dođavola, čovek koji je ovo uspeo da zamisli?" I to mi se retko dešava. Parfem obično upoznaješ kroz note.

Ovoga puta sam poželeo da upoznam autora. Ako ikada budem imao priliku da sednem sa Thomasom Kosmalom na kafu, verovatno ga uopšte neću pitati kako je napravio Le Sel de la Terre. To pitanje će mu postaviti još hiljadu ljudi. Ja bih ga pitao nešto sasvim drugo.

Koliko si puta pomislio da odustaneš... i koliko si puta izgovorio: "Ne... još nije to." Imam osećaj da odgovor na to pitanje miriše mnogo više od bilo koje note koja se danas nalazi u ovoj bočici.

—
Čarli
Remember. PlayNice.`
    },
    relatedProducts: [
      "thomas-kosmala-no7-le-sel-de-la-terre"
    ]
  },
  {
    id: 17,
    date: {
      en: "11 Jul",
      sr: "11 Jul"
    },
    image: "/journal/world-cup-var.jpg",
    title: {
      en: "Once, it was enough for the ball to cross the line.",
      sr: "Nekad je bilo dovoljno da lopta pređe gol-liniju."
    },
    excerpt: {
      en: "Technology keeps getting smarter. Football... somehow keeps getting more complicated.",
      sr: "Tehnologija je sve pametnija. Fudbal... nekako sve komplikovaniji."
    },
    content: {
      en: `Last night I sat down to watch a football match. Or at least I think I did. At one point I wasn't even sure whether I was watching football or the latest crime series where every character carries a whistle.

Football used to be simple. One ball. Two goals. Twenty-two players. One referee. If your team got robbed, you'd yell at the TV for five minutes, go outside for some fresh air and move on with your life.

Today... the ball has sensors. The referee has an earpiece. VAR has its own room. The VAR room practically needs another VAR room. At this rate, even the grass will have a lawyer.

I read that technology can detect whether a player touched the ball with a single hair. A single hair. Come on... This morning I couldn't even find my glasses while they were sitting on top of my head, yet someone expects me to believe the ball felt one hair on a boot. Next year they'll probably measure whether the striker was emotionally ready to score. Impressive. Seriously.

—

Then you read that one referee never even made it to the tournament. Another one is under investigation. A third missed a penalty. A fourth somehow saw something nobody else on Earth managed to see.

And then comes the kind of headline no screenwriter would dare hand to a producer: Donald Trump reportedly stepped in to have an American player's red card overturned. At that point I honestly gave up trying to understand what I was watching. Because when presidents start dealing with red cards, you're no longer sure whether you're watching the World Cup or a United Nations session with a football.

—

And one more thing. At this pace, football academies will soon teach falling before passing. Players used to train volleys, first touch and free kicks. Now some of them seem to practice facial expressions.

A defender brushes their shoulder. They grab their face. They fall. They roll around. They peek through their fingers to see whether the referee bought it. Thirty seconds later they're sprinting sixty metres like nothing ever happened.

If acting counted toward the Ballon d'Or... some forwards would have more trophies than Messi.

—

Infantino? Of course he's smiling. The man looks like he could sell snow to Norwegians, sand to the Sahara and convince everyone they got a fantastic deal.

I'll give him one thing. He actually managed it. He turned the simplest game in the world into the most complicated one. And after a while you start thinking... maybe only the ball knows what really happened. And that little rascal has kept quiet for a century and a half.

—

What I miss the most is the time when you could argue with your friends about an offside and nobody could be completely certain.

Now we wait for animations. Lines. Graphics. Three camera angles. Five slow-motion replays. Reports. Statements. Committees. Appeals. Only then do we celebrate the goal — if we're even allowed to celebrate it.

—

Maybe I'm old-fashioned... but I'd rather technology helped football. Not the other way around. Because when the match lasts ninety minutes but the debate lasts three days, you start wondering what you actually watched: football or a software presentation.

—

Anyway. Next time I see a referee waiting for confirmation from three cities, two server rooms and one satellite before pointing to the centre circle, I'll do exactly what I've always done: get up from the couch, complain, open a beer and look forward to the next match.

Because it seems that we, the fans, are the only technology football still hasn't managed to break.

And honestly... I hope it stays that way.

—
Charlie
Remember. PlayNice.`,
      sr: `Sedim sinoć i gledam utakmicu. Bar mislim da gledam utakmicu. U jednom trenutku više nisam bio siguran da li pratim fudbal ili novu sezonu neke kriminalističke serije u kojoj svaki lik nosi pištaljku.

Nekad je fudbal bio prilično jednostavna igra. Lopta. Dva gola. Dvadeset dva čoveka. Jedan sudija. Ako te pokradu, psuješ televizor pet minuta, izađeš napolje da prošetaš i sutra nastaviš da živiš.

Danas... lopta ima senzore. Sudija ima slušalicu. VAR ima svoju sobu. VAR soba ima svoju VAR sobu. Još malo pa će i trava imati advokata.

Čitam da tehnologija može da izmeri da li je igrač dodirnuo loptu jednom dlakom na nozi. Jednom dlakom. Brate... Ja jutros nisam mogao da pronađem naočare koje su mi sve vreme bile na glavi, a neko će meni objasniti da je lopta osetila jednu dlaku na kopački. Sledeće godine će, verovatno, meriti i da li je napadač u trenutku šuta bio emotivno spreman da postigne gol. Svaka čast. Ozbiljno.

—

Onda pročitaš da jedan sudija nije ni stigao na prvenstvo. Drugi je pod istragom. Treći nije video penal. Četvrti je video nešto što niko drugi na planeti nije video.

A onda dolazi vest koju ni najbolji scenarista ne bi smeo da preda producentu. Donald Tramp se umešao kako bi američkom reprezentativcu bio poništen crveni karton. E, tu sam već odustao od pokušaja da shvatim šta gledam. Jer kad predsednici država počnu da rešavaju kartone, više nisi siguran da li pratiš Svetsko prvenstvo ili sednicu Ujedinjenih nacija sa loptom.

—

I još nešto. Ako ovako nastavimo, uskoro će se na fudbalskim akademijama prvo učiti padanje, pa tek onda dodavanje. Nekad su ljudi trenirali volej, prijem lopte i slobodne udarce. Danas pojedini treniraju izraz lica.

Dodirne ga protivnik po ramenu. Ovaj se uhvati za lice. Padne. Previja se. Gleda sudiju kroz prste kao dete koje proverava da li je mama videla da je palo. Posle trideset sekundi ustane i sprinta šezdeset metara kao da se ništa nije dogodilo.

Kad bi gluma ulazila u tabelu za Zlatnu loptu... mislim da bi neki napadači imali više trofeja od Mesija.

—

Infantino? On se, naravno, smeška. Čovek izgleda kao da bi mogao da proda sneg Norvežanima, pesak Sahari i još da ih ubedi kako su napravili odličan posao.

Moram da mu priznam jednu stvar. Uspeo je. Od najjednostavnije igre na svetu napravio je najkomplikovaniju. I u jednom trenutku počneš da razmišljaš... možda jedino lopta zna šta se stvarno dogodilo. A ona, bezobraznica, ćuti već vek i po.

—

Najviše mi nedostaje ono vreme kada si mogao da se posvađaš sa društvom oko ofsajda i da niko nije bio potpuno siguran.

Danas svi čekamo animaciju. Linije. Grafiku. Tri ugla. Pet usporenih snimaka. Izveštaj. Saopštenje. Komisiju. Žalbu. Pa tek onda proslavimo gol — ako ga uopšte smemo proslaviti.

—

I možda sam staromodan... ali voleo bih da tehnologija pomaže fudbalu. Ne da fudbal pomaže tehnologiji. Jer kad utakmica traje devedeset minuta, a rasprava o njoj naredna tri dana, čovek počne da se pita šta je zapravo gledao: fudbal ili prezentaciju softvera.

—

Ali dobro. Kad sledeći put budem video da sudija čeka potvrdu iz tri različita grada, dve server sobe i jednog satelita pre nego što pokaže na centar, uradiću isto što radim ceo život: ustaću sa kauča, opsovaću, otvoriću pivo i jedva ću čekati sledeću utakmicu.

Jer izgleda da smo mi navijači jedina tehnologija koju fudbal još uvek nije uspeo da pokvari.

I iskreno... nadam se da će tako i ostati.

—
Čarli
Remember. PlayNice.`
    }
  },
  {
    id: 18,
    date: {
      en: "12 Jul",
      sr: "12 Jul"
    },
    image: "/journal/fifty-one-day.jpg",
    title: {
      en: "50... And one day.",
      sr: "50... I jedan dan."
    },
    excerpt: {
      en: "One morning you wake up and realize nothing has changed. Except the questions you finally dare to ask yourself.",
      sr: "Jednog jutra probudiš se i shvatiš da se nije promenilo ništa. Osim pitanja koja se konačno usudiš da postaviš sebi."
    },
    content: {
      en: `Fifty. A strange number.

What happened? Seriously. When did this happen?

When you're twenty, fifty feels like some distant planet. That's where other people go. Serious people. Proper adults. You stay here. At thirty you think there's plenty of time. At forty you're still negotiating with yourself.

Then one morning you open your eyes. Fifty. And one day. And you realize nothing spectacular has happened. The sun came up just like yesterday. Coffee tastes exactly the same.

But inside your head... someone finally dares to ask the question you've been successfully avoiding for years.

**Was that it?**

You no longer wonder what you'll be when you grow up. Now you wonder who you've actually become.

You flip through your life like an old photo album. Some pictures deserve a frame. Others deserve a fire. In some of them you barely recognize the man who's smiling.

You wonder what would've happened if you'd said "yes." Or "no." If you'd stayed. If you'd left. If you'd been a little braver, a little less proud, a little more patient. If you'd taken that job, turned down the other one, called that person or walked down the road that scared you.

How many lives can disappear because of one single decision? You don't know. Nobody does.

Maybe you could've been a world-class athlete. Maybe a doctor. A pilot. A musician. Maybe the kind of person who flies from continent to continent and has dinner with people whose names appear on the news. Maybe you could've been rich. Maybe famous. Maybe someone completely different.

But you weren't. You became the man sitting here today, alone with his thoughts, trying to calculate how much time is left.

Is there enough? If you're lucky... twenty years? Thirty? Maybe more. Maybe much less.

For the first time, the mathematics of life no longer feels abstract. Every year suddenly becomes more valuable than the one before.

And yes... it scares you. Not the number. The speed.

Years don't pass anymore. They disappear. You finally get used to writing the new year and it's already July. You blink — it's December again. You blink — the child you once held in your arms is driving a car. You blink — your parents grow old and friends begin to leave.

And for the first time you realize time isn't infinite.

That hurts everyone differently. Some because they never had a family. Some because they lost the one they had. Some because one day they look around and realize the world kept changing while they weren't paying attention.

There's only you. A few trips. A handful of friends. An apartment that might not even be yours.

**Am I too late?**

I don't know. I think that's the wrong question. Maybe it doesn't matter whether you're late. Maybe what matters is whether you've stopped.

Because there's a big difference. If you've stopped, then the years really are winning.

But if a song can still make you smile, if you still want to see Iceland, learn to fly a small airplane, run a half marathon, write a book, fall in love or build something of your own — then you're not finished. Not even close.

People often imagine life as a straight line: school, work, marriage, kids, retirement. But life rarely follows the schedule. Some people find love at twenty. Some at sixty. Some succeed at twenty-five, while others only succeed after everyone else has stopped believing in them.

There's no law saying your best years are already behind you. Only fear says that. Fear rarely tells the truth.

Will medicine help us live longer? Probably. Will technology one day make seventy feel like today's fifty? Maybe. Artificial intelligence is already changing the world faster than any of us imagined. Maybe we'll live longer. Maybe healthier. Maybe more actively.

I don't know. But I know one thing.

I hope we do.

Because I need more time. Already. Not to become younger, but to become the man I always believed I could be.

And maybe that's the answer.

At fifty... and one day... you shouldn't think about how much time is left. You should think about what you'll never postpone again: who you'll call, where you'll go, what you'll learn, what you'll forgive, what you'll finally dare to do.

Because maybe fifty isn't the end of the first half. Maybe it's the end of excuses.

Maybe life doesn't begin at twenty. Maybe not even at thirty. Maybe for some people it only begins the day they honestly admit to themselves that time isn't infinite.

And that often happens...

At fifty. And one day.

—
Charlie
Remember. PlayNice.`,
      sr: `Pedeset. Čudna brojka.

Šta se desilo? Ozbiljno. Kad se ovo dogodilo?

Dok imaš dvadeset, pedeset izgleda kao neka daleka planeta. Tamo odlaze neki drugi ljudi. Ozbiljni. Odrasli. Ti ostaješ ovde. Sa trideset misliš da ima vremena. Sa četrdeset još uvek pregovaraš sa sobom.

A onda jednog jutra otvoriš oči. Pedeset. I jedan dan. I shvatiš da se ništa spektakularno nije dogodilo. Sunce je izašlo kao i juče. Kafa ima isti ukus.

Ali u glavi... kao da se neko prvi put usudio da postavi pitanje koje si godinama uspešno izbegavao.

**Je l' to bilo to?**

Ne razmišljaš više šta ćeš biti kad porasteš. Sad razmišljaš šta si zapravo postao.

Prelistavaš život kao album starih fotografija. Neke bi uokvirio. Neke bi spalio. Na nekima ni ne prepoznaješ čoveka koji se smeje.

Pitaš se šta bi bilo da si tada rekao "da". Ili "ne". Da si ostao. Da si otišao. Da si imao više hrabrosti, manje ponosa, više strpljenja. Da si prihvatio onaj posao, odbio onaj drugi, pozvao onu osobu ili samo jednom krenuo putem koji te plašio.

Koliko života čovek može da ne proživi zbog jedne jedine odluke? Ne znaš. Niko ne zna.

Možda si mogao biti vrhunski sportista. Možda doktor. Pilot. Muzičar. Možda čovek koji leti sa kontinenta na kontinent i večera sa ljudima čija se imena pojavljuju u vestima. Možda si mogao biti bogat. Možda poznat. Možda potpuno neko drugi.

Ali nisi. Postao si ovaj čovek koji danas sedi sam sa svojim mislima i pokušava da izračuna koliko je vremena ostalo.

Ima li ga uopšte dovoljno? Ako bude sreće... dvadeset godina? Trideset? Možda više. Možda mnogo manje.

Prvi put matematika života više nije apstraktna. Svaka sledeća godina postaje dragocenija od prethodne.

I da... plaši te. Ne sama brojka. Nego brzina.

Godine više ne prolaze. One nestaju. Tek se navikneš da pišeš novu godinu, a već je jul. Trepneš — opet je decembar. Trepneš — neko dete koje si držao u naručju vozi automobil. Trepneš — roditelji ostare, prijatelji počnu da odlaze.

I prvi put shvatiš da vreme nije beskonačno.

I to boli svakoga na drugačiji način. Nekoga zato što nema porodicu. Nekoga zato što je izgubio ljude koje je imao. Nekoga zato što se jednog dana okrene oko sebe i shvati koliko se svet promenio dok nije gledao.

Ostaneš samo ti. Poneko putovanje. Par prijatelja. Stan koji možda i nije tvoj.

**Jesam li zakasnio?**

Ne znam. Mislim da je to pogrešno pitanje. Možda nije važno da li si zakasnio. Možda je važnije da li si stao.

Jer postoji velika razlika. Ako si stao, onda godine stvarno pobeđuju.

Ali ako se još uvek raduješ nekoj pesmi, ako i dalje želiš da vidiš Island, naučiš da letiš malim avionom, istrčiš polumaraton, napišeš knjigu, zaljubiš se ili napraviš nešto svoje — onda još nisi završio. Nisi ni blizu.

Ljudi često zamišljaju život kao pravu liniju: škola, posao, brak, deca, penzija. Ali život retko poštuje raspored. Neko ljubav pronađe sa dvadeset. Neko sa šezdeset. Neko uspe sa dvadeset pet, a neko tek kada svi prestanu da veruju u njega.

Ne postoji zakon koji kaže da su najbolje godine već prošle. To govori samo strah. A strah retko kada govori istinu.

Hoće li medicina produžiti život? Verovatno. Hoće li tehnologija omogućiti da sedamdesete jednog dana izgledaju kao današnje pedesete? Možda. Veštačka inteligencija već danas menja svet brže nego što smo mogli da zamislimo. Možda ćemo živeti duže. Možda zdravije. Možda aktivnije.

Ne znam. Ali znam jednu stvar.

Nadam se da hoćemo.

Jer meni treba još vremena. Već sada. Ne da bih bio mlađi, nego da stignem da postanem čovek za kog sam oduvek mislio da mogu biti.

I možda je upravo to odgovor.

Sa pedeset i jednim danom ne treba razmišljati o tome koliko je ostalo. Treba razmišljati šta više nikada nećeš odlagati: koga ćeš pozvati, gde ćeš otići, šta ćeš naučiti, šta ćeš oprostiti, šta ćeš konačno pokušati.

Jer možda pedeseta nije kraj prve polovine. Možda je kraj izgovora.

Možda život ne počinje sa dvadeset. Možda ne počinje ni sa trideset. Možda nekima počne tek onda kada prvi put iskreno priznaju sebi da vreme nije beskonačno.

A to se često dogodi...

Sa pedeset. I jednim danom.

—
Čarli
Remember. PlayNice.`
    },
    links: [
      {
        label: {
          en: "Explore the collection",
          sr: "Istraži kolekciju"
        },
        action: "shop"
      }
    ],
    relatedProducts: [
      "bvlgari-man-in-black-edp",
      "mancera-aoud-lemon-mint",
      "ysl-myslf-edp",
      "prada-luna-rossa-ocean-edt"
    ]
  },
  {
    id: 19,
    date: {
      en: "25 Jul",
      sr: "25 Jul"
    },
    image: "/journal/scent-has-no-navigation.jpg",
    title: {
      en: "Scent Has No Navigation.",
      sr: "Miris nema navigaciju."
    },
    excerpt: {
      en: "It's good to have a map. Except people rarely get lost among notes. They get lost trying to smell like someone else.",
      sr: "Lepo je imati mapu. Samo što ljudi uglavnom ne zalutaju među notama. Zalutaju pokušavajući da mirišu kao neko drugi."
    },
    content: {
      en: `While we were creating **The Note Map**, I watched them carefully arrange lemon, leather, tobacco, vanilla and ambroxan. Every note found its place. Every fragrance family got its color. Everything was neat, clear and logical.

And then I thought:

**It's good to have a map.  
Except people rarely get lost among notes.  
They get lost trying to smell like someone else.**

I'm not exactly sure when that happened. Maybe when we started asking what a fragrance smells similar to before checking whether we actually liked it. Maybe when we began believing that there are scents for successful people, scents for serious men and scents for women who enter a room two minutes before the door opens.

And, of course, fragrances for compliments. That special category of perfume which, according to the internet, should make a complete stranger stop you in the street, forget where they were going and ask for the exact name, batch code and purchase link.

That has never happened to me. A man did stop me in the street once. He asked where the post office was. I smelled good, though.

Today, a fragrance rarely arrives alone. Before it comes the rating, the review, the season, the recommended occasion, the longevity measured in hours and a man on the internet claiming that its projection is "nuclear."

By the time the fragrance finally reaches the skin, we already know so much about it that there's almost no room left to actually smell it. We expect lemon. We wait for leather. We search for vanilla. We count the hours. And sometimes we become so focused on what we're supposed to notice that we miss what actually happened to us.

Maybe that fragrance didn't take you to the coast of Sicily. Maybe it reminded you of a hotel hallway where you were once happy. Maybe it isn't "confident and dominant." Maybe it simply made you feel calm.

That isn't the wrong answer. Your nose is under no obligation to read the product description.

That's why The Note Map wasn't created to tell you who you should be. It doesn't know what kind of shirt you're wearing, whether you're going out tonight or staying home, or whether you'll wear a fresh citrus fragrance in the middle of winter simply because you were missing the sun that morning.

The map shows you the terrain. Here is bergamot. Over there is tobacco. A little farther away, leather, pepper, iris or vanilla. You can see where the fragrance begins, where it might go and what may be waiting around the next corner.

But the map doesn't choose the direction. And it shouldn't.

Because the most interesting part of a fragrance begins exactly where the explanation ends: on the skin, in time, on some perfectly ordinary Tuesday that, for reasons you can't quite explain, you'll remember by its scent.

Maybe you'll choose a fragrance that doesn't "belong" to you. Too dark. Too sweet. Too young. Too serious. The internet will certainly have an opinion about it. The internet always has an opinion.

But if you bring your wrist closer to your nose several times during the day, just to check once more whether it's still there, you've probably arrived exactly where you needed to be.

Not because you followed the perfect route. But because somewhere along the way, you stopped trying to smell like someone else.

**The map is here.  
The direction is yours.**

—
Charlie
Remember. PlayNice.`,
      sr: `Dok smo pravili **The Note Map**, gledao sam ih kako pažljivo raspoređuju limun, kožu, duvan, vanilu i ambroksan. Svaka nota dobila je svoje mesto. Svaka porodica svoju boju. Sve uredno, pregledno i logično.

A onda sam pomislio:

**Lepo je imati mapu.  
Samo što ljudi uglavnom ne zalutaju među notama.  
Zalutaju pokušavajući da mirišu kao neko drugi.**

Ne znam tačno kada se to dogodilo. Možda onda kada smo počeli da pitamo na šta neki parfem liči, pre nego što smo proverili da li nam se uopšte dopada. Možda kada smo poverovali da postoje mirisi za uspešne ljude, mirisi za ozbiljne muškarce i mirisi za žene koje ulaze u prostoriju dva minuta pre nego što se vrata otvore.

I, naravno, mirisi za komplimente. Ta posebna kategorija parfema koji bi, prema internetu, trebalo da natera potpunog stranca da vas zaustavi na ulici, zaboravi gde je krenuo i zatraži tačan naziv, batch code i link za kupovinu.

Meni se to nikada nije dogodilo. Jednom me je zaustavio čovek na ulici. Pitao me je gde je pošta. Ipak, lepo sam mirisao.

Danas parfem retko dolazi sam. Pre njega stignu ocena, recenzija, godišnje doba, preporučena prilika, trajnost izražena u satima i čovek sa interneta koji tvrdi da je projekcija „nuklearna“.

Dok parfem konačno stigne do kože, o njemu već znamo toliko da gotovo nema prostora da ga zaista pomirišemo. Očekujemo limun. Čekamo kožu. Tražimo vanilu. Brojimo sate. A ponekad se toliko skoncentrišemo na ono što bi trebalo da osetimo da propustimo ono što nam se stvarno dogodilo.

Možda vas taj parfem nije odveo na obalu Sicilije. Možda vas je podsetio na hodnik hotela u kojem ste nekada bili srećni. Možda nije „samouveren i dominantan“. Možda vas je samo smirio.

To nije pogrešan odgovor. Nos nema obavezu da pročita opis proizvoda.

Zato The Note Map nije napravljena da vam kaže ko treba da budete. Ona ne zna kakvu košulju nosite, da li izlazite večeras ili ostajete kod kuće, niti da li ćete staviti svež citrusni parfem usred zime samo zato što vam je tog jutra nedostajalo sunce.

Mapa vam pokazuje teren. Ovde je bergamot. Tamo je duvan. Malo dalje koža, biber, iris ili vanila. Možete da vidite odakle miris polazi, kuda bi mogao da ode i šta vas možda čeka iza sledećeg ugla.

Ali mapa ne bira pravac. I ne bi trebalo.

Jer najzanimljiviji deo parfema počinje upravo tamo gde se objašnjenje završava: na koži, u vremenu, u nekom sasvim običnom utorku koji ćete, iz razloga koje ne možete lepo da objasnite, zapamtiti po mirisu.

Možda ćete izabrati parfem koji vam „ne pripada“. Previše je taman. Previše sladak. Previše mlad. Previše ozbiljan. Internet će sigurno imati mišljenje o tome. Internet uvek ima mišljenje.

Ali ako nekoliko puta tokom dana približite zglob nosu, samo da još jednom proverite da li je i dalje tu — verovatno ste stigli gde treba.

Ne zato što ste pratili savršenu rutu. Nego zato što ste, negde usput, prestali da pokušavate da mirišete kao neko drugi.

**Mapa je tu.  
Pravac je vaš.**

—
Čarli
Remember. PlayNice.`
    },
    links: [
      {
        label: {
          en: "Choose your direction",
          sr: "Izaberi svoj pravac"
        },
        action: "shop"
      }
    ],
    relatedProducts: [
      "rayhaan-nocturno-elixir",
      "ysl-myslf-edp",
      "french-avenue-ravine-ice",
      "lattafa-khamrah-waha-edp"
    ]
  },
  {
    id: 20,
    date: {
      en: "11 Aug",
      sr: "11 Avg"
    },
    image: "/journal/article20.png",
    title: {
      en: "The Honey Badger Doesn't Read the Comments.",
      sr: "Medojedni jazavac ne čita komentare."
    },
    excerpt: {
      en: "Everyone wants to be themselves—as soon as everyone else confirms it's a good idea. The honey badger doesn't have that problem.",
      sr: "Svi žele da budu svoji — čim im ostali potvrde da je to dobra ideja. Medojedni jazavac nema taj problem."
    },
    content: {
      en: `Everyone wants to be different. Just not so different that they have to be alone in it. We want to be noticed, but not enough for someone in the comments to write: “This just isn't for me.” We like authenticity best when it comes with a return policy, an average rating of 4.8 and several influencers who have already tested it safely. In other words: be yourself. But keep the receipt.

—

The honey badger doesn't have that problem. It doesn't walk into the savannah asking: “Excuse me, is it still fashionable to be short, stocky and unpleasantly confident?” It doesn't care. It wears the same black-and-white coat its entire life, with no seasonal collections, no stylist and no post saying: “So many of you have been asking where it's from.” No one asked. Everyone was busy running away.

The honey badger may be nature's finest example of authenticity. Not because it's the prettiest, strongest or largest. The lion is bigger. The cheetah is faster. The peacock has done a better job with personal branding. But none of them looks as if it has just received a restraining order from three national parks. That is its advantage.

—

We, on the other hand, can spend three days choosing a fragrance that will represent our unique personality and then type: “Do women like this fragrance?” That is usually where the unique personality dies. It didn't even make it to the base notes. We want a signature scent, provided the internet signs it first. We want a fragrance people will remember us by, preferably the same one they already remember another seven million people by. The honey badger doesn't look for a signature.

It is the signature. Black underneath. A grey stripe across its back. Short legs. Long claws. The expression of a man you have just told that complaints can only be submitted through the online form. A complete identity. No consultant required. It also has its own scent signature. When things get serious, it can release an extremely unpleasant smell from its anal glands, rather like a skunk. That may not be the fragrance I would recommend for a first date.

But you have to admit it has projection. And a very clearly defined target audience: everyone who needs to leave immediately. The honey badger doesn't ask whether its scent is “mass appealing”. Its approach is more “mass leaving”.

—

And this is where we get to our problem. We have grown so used to measuring ourselves through other people's reactions that we have turned taste into a survey. We no longer choose what we like. We choose what we expect others will approve of us liking. That is already serious administration. A man puts on a fragrance, leaves the house and, instead of living, keeps a mental spreadsheet: First compliment — colleague, 09:42. Second compliment — delivery driver, possibly just being polite.

Third compliment — wasn't a compliment; he asked whether there was a petrol leak nearby. The honey badger doesn't have Excel. It has claws. That makes meetings considerably shorter. Of course, the point is not that we should live like one. When someone disapproves of your choice of shoes, you shouldn't dig a tunnel under their house and eat their poultry. That would be excessive.

Even for LinkedIn.

—

Still, we could learn something from an animal that a venomous snakebite sometimes doesn't stop permanently—it merely disrupts its schedule. The honey badger is not completely immune to every venom, nor is it indestructible. The internet has turned it into an action hero, but nature was more nuanced. Its body developed resistance to certain snake neurotoxins. Thick, loose skin offers additional protection, and if a predator grabs it, the honey badger can turn around inside its own skin and bite back.

Read that again. It can turn around inside its own skin. Most people cannot even turn around their own axis, let alone inside an opinion once they have posted it online. One comment bites us and we spend three days emotionally paralysed. A cobra bites the honey badger, it gathers itself and carries on dealing with the cobra. Not because the venom has no effect.

It does. The honey badger simply doesn't let it decide what happens next. Perhaps that is authenticity. It doesn't mean never doubting yourself, ignoring every piece of advice or entering every conflict simply to prove that you can. You can listen to someone else's opinion. You just don't have to give it the keys, the alarm code and permission to choose your fragrance. The honey badger doesn't hold a press conference every time it survives. It doesn't post a black-and-white photograph with the caption: “They underestimated me. Now they watch me succeed.” It simply carries on.

Probably towards the next beehive.

—

Authenticity isn't loudly explaining to everyone who you are. It is when you stop changing the answer every time somebody raises an eyebrow. Wear the fragrance you love. If someone else likes it — lovely. If nobody likes it — check the dosage. We do live in society, after all, not in the Kalahari. But don't immediately start changing yourself. Maybe you sprayed too much. Maybe it was the wrong occasion. Or perhaps everyone around you has spent so long wearing safe choices that something genuinely personal simply surprised them.

The honey badger knows the difference between adapting and surrendering. It isn't stupid. Although its biography sounds as if it was written by a man who sells energy drinks, the animal doesn't attack everything it sees. It is independent, resourceful and persistent. It digs, hunts, searches for food and generally minds its own business. The problem begins when its business decides to fight back. That is when negotiations end. We may not need its aggression.

But a little of its internal organisation would do us good. It doesn't ask: “Am I brave enough?” It asks: “Where is the beehive?” It doesn't ask: “What if they judge me?” Probably because those judging it tend to do so from a safe distance and from behind a tree. It doesn't ask whether its black-and-white appearance sends the wrong message, either.

The message is perfectly clear.

—

What we lack may not be more advice on how to find ourselves. We have enough advice. Every morning the internet offers us seventeen ways to be authentic, twelve habits of successful people and one fragrance that will supposedly change our lives. It won't. A fragrance can change your mood, awaken a memory, start a conversation or make an ordinary Tuesday feel as though it has a better budget. But it cannot decide for you. You have to do that yourself. Preferably without a survey.

—

So the next time you choose something of your own — a fragrance, an opinion, a shirt or a life that doesn't look particularly impressive on someone else's screen — remember the honey badger. You don't have to eat a cobra. It is enough not to let every venomous comment convince you that you were wrong. You don't have to attack a lion. It is enough to stop behaving like prey whenever someone fails to understand your choice. And you don't have to release a defensive odour.

Several very serious fragrances from the eighties have already taken care of that. Be yourself. Not because it is currently fashionable. Not because it sounds good in a profile description. And not because I told you to. Be yourself because the alternative is rather exhausting: spending your life wearing someone else's taste while waiting for a compliment from people who borrowed theirs as well.

The honey badger would never do that. It has its own coat, its own scent and its own direction. And if a king cobra happens to be standing in that direction — let us just say that royal titles do not mean very much in that forest.

—

And one more thing: if skunks and honey badgers released Swiss Arabian Musk 01, the world would be just a tiny bit more beautiful. Both they and everyone around them… would live muuuch better.

—
Charlie
Remember. PlayNice.`,
      sr: `Danas svi žele da budu drugačiji. Samo ne toliko drugačiji da u tome ostanu sami. Želimo da se primetimo, ali ne toliko da neko u komentarima napiše: „Meni ovo ipak nije leglo.“ Autentičnost nam se najviše dopada kada dolazi sa garancijom povrata novca, prosečnom ocenom 4,8 i nekoliko influensera koji su je već bezbedno isprobali. Drugim rečima: budite svoji. Ali sačuvajte račun.

—

Medojedni jazavac nema taj problem. On ne ulazi u savanu pitajući: „Izvinite, da li je danas još uvek moderno biti nizak, zdepast i neprijatno samouveren?“ Ne zanima ga. Ima crno-beli kaput koji nosi čitavog života, bez sezonskih kolekcija, bez stiliste i bez objave: „Mnogi ste me pitali odakle je.“ Niko ga nije pitao.

Svi su bili zauzeti bežanjem. Medojedni jazavac je možda najbolji primer autentičnosti u prirodi. Ne zato što je najlepši, najjači ili najveći. Lav je veći. Gepard je brži. Paun je bolje rešio lični brending. Ali nijedna od tih životinja ne izgleda kao da je upravo dobila zabranu prilaska u tri nacionalna parka. To je njegova prednost.

—

Mi, s druge strane, možemo provesti tri dana birajući parfem koji će predstavljati našu jedinstvenu ličnost, a onda ukucati: „Da li žene vole ovaj parfem?“ Tu obično umre jedinstvena ličnost. Nije čak ni stigla do baze. Tražimo signature scent, ali pod uslovom da ga internet prethodno potpiše. Želimo miris po kojem će nas pamtiti, ali najradije onaj po kojem već pamte još sedam miliona ljudi. Medojedni jazavac ne traži signature.

On jeste signature. Crna donja polovina. Siva pruga preko leđa. Kratke noge. Dugačke kandže. Izraz lica čoveka kome ste upravo rekli da reklamaciju može podneti isključivo putem formulara. Kompletan identitet. Bez konsultanta. A ima i sopstveni mirisni potpis. Kada situacija postane ozbiljna, može da ispusti veoma neprijatan miris iz analnih žlezda, slično tvoru. To možda nije parfem koji bih preporučio za prvi sastanak.

Ali se mora priznati da ima projekciju. I vrlo jasnu ciljnu grupu: svi koji treba odmah da odu. Medojedni jazavac ne pita da li je njegov miris „mass appealing“. Njegov pristup je više „mass leaving“.

—

I tu dolazimo do problema sa nama. Toliko smo navikli da merimo sebe reakcijama drugih da smo ukus pretvorili u anketu. Više ne biramo ono što nam se dopada. Biramo ono za šta očekujemo da će drugi odobriti da nam se dopada. To je već ozbiljna administracija. Čovek stavi parfem, izađe iz kuće i umesto da živi, mentalno vodi Excel tabelu: Prvi kompliment — koleginica, 09:42. Drugi kompliment — dostavljač, možda samo ljubazan.

Treći kompliment — nije bio kompliment, pitao je da li negde curi benzin. Medojedni jazavac nema Excel. Ima kandže. To značajno skraćuje sastanke. Naravno, nije poenta da živimo kao on. Kada vam neko ne odobri izbor cipela, ne treba da mu iskopate tunel ispod kuće i pojedete živinu. To bi bilo preterano.

Čak i za LinkedIn.

—

Ali nešto bismo mogli da naučimo od životinje koju ugriz otrovne zmije ponekad ne zaustavi trajno, već joj samo poremeti raspored. Medojedni jazavac nije potpuno imun na svaki otrov i nije neuništiv. Internet je od njega napravio akcionog heroja, ali priroda je bila nijansiranija. Njegovo telo je razvilo otpornost na određene zmijske neurotoksine. Debela, labava koža dodatno ga štiti, a ako ga grabljivica uhvati, on može da se okrene unutar sopstvene kože i ugrize je.

Pročitajte to ponovo. Može da se okrene unutar sopstvene kože. Većina ljudi ne može da se okrene ni oko sopstvene ose, a kamoli unutar sopstvenog mišljenja kada ga jednom objavi na internetu. Nas ugrize jedan komentar i tri dana ležimo emotivno paralizovani. Njega ugrize kobra, on se malo sabere i nastavi da rešava problem sa kobrom. Ne zato što otrov ne deluje.

Deluje. Samo mu nije prepustio odluku šta će dalje. Možda je upravo to autentičnost. To ne znači da nikada ne sumnjate, da ignorišete svaki savet ili da ulazite u svaki sukob samo da biste dokazali da možete. Možete saslušati tuđe mišljenje. Samo mu ne morate dati ključeve, šifru alarma i pravo da vam bira parfem. Medojedni jazavac ne organizuje konferenciju za medije svaki put kada preživi. Ne objavljuje crno-belu fotografiju sa tekstom: „Potcenili su me. Sada gledaju moj uspeh.“

On samo nastavi dalje. Verovatno prema sledećoj košnici.

—

Autentičnost nije da svima glasno objašnjavate ko ste. To je kada prestanete da menjate odgovor svaki put kada neko podigne obrvu. Nosite miris koji volite. Ako se nekome dopadne — lepo. Ako se nikome ne dopadne — proverite dozu. Ipak živimo u društvu, ne u Kalahariju. Ali nemojte odmah menjati sebe. Možda ste stavili previše. Možda je pogrešna prilika. A možda su svi oko vas proveli toliko vremena noseći bezbedne izbore da ih je nešto stvarno lično jednostavno iznenadilo.

Medojedni jazavac zna razliku između prilagođavanja i predaje. On nije glup. Iako njegova biografija zvuči kao da ju je pisao čovek koji prodaje energetska pića, životinja ne napada sve što vidi. Samostalna je, snalažljiva i uporna. Kopa, lovi, traži hranu i uglavnom gleda svoja posla. Problem nastaje kada njegova posla odluče da uzvrate. Tada se pregovori završavaju. Možda nam ne treba njegova agresija. Ali dobro bi nam došao deo njegove unutrašnje organizacije.

On ne pita: „Da li sam dovoljno hrabar?“ On pita: „Gde je košnica?“ Ne pita: „Šta ako me osuđuju?“

Verovatno zato što oni koji ga osuđuju obično to rade sa bezbedne udaljenosti i iza drveta. Ne pita ni da li njegov crno-beli izgled šalje pogrešnu poruku. Poruka je sasvim jasna.

—

Ono što nam nedostaje možda nije još saveta o tome kako da pronađemo sebe. Saveta imamo dovoljno. Svakog jutra internet nam ponudi sedamnaest načina da budemo autentični, dvanaest navika uspešnih ljudi i jedan parfem koji će navodno promeniti naš život. Neće. Parfem može da promeni raspoloženje, probudi uspomenu, otvori razgovor ili učini da vam običan utorak deluje kao da ima bolji budžet. Ali ne može da odluči umesto vas. To morate sami. Po mogućnosti bez ankete.

—

Zato sledeći put kada birate nešto svoje — miris, mišljenje, košulju ili život koji ne izgleda naročito dobro na tuđem ekranu — setite se medojednog jazavca. Ne morate pojesti kobru. Dovoljno je da ne dozvolite svakom otrovnom komentaru da vas ubedi da ste pogrešili. Ne morate napasti lava. Dovoljno je da prestanete da se ponašate kao plen svaki put kada neko ne razume vaš izbor. I ne morate ispustiti odbrambeni miris.

Za to već postoji nekoliko veoma ozbiljnih parfema iz osamdesetih. Budite svoji. Ne zato što je to trenutno popularno. Ne zato što dobro zvuči u opisu profila. I ne zato što vam to ja rekao. Budite svoji zato što je alternativa prilično zamorna: provesti život noseći tuđi ukus, čekajući kompliment od ljudi koji su svoj takođe pozajmili.

Medojedni jazavac to nikada ne bi uradio. On ima svoj kaput, svoj miris i svoj pravac. A ako mu se na tom pravcu nađe kraljevska kobra — recimo samo da kraljevske titule u toj šumi ne znače mnogo.

—

I još nešto: da tvorovi i medojedni jazavci ispuštaju Swiss Arabian Musk 01, svet bi bio za trunku lepše mesto. I oni, a i okolina.. bi živeli mnooogo kvalitetnije.

—
Čarli
Remember. PlayNice.`
    },
    relatedProducts: [
      "swiss-arabian-musk-01"
    ],
    links: [
      {
        label: {
          en: "Watch the honey badger in action",
          sr: "Pogledaj medojednog jazavca na delu"
        },
        url: "https://www.youtube.com/watch?v=Fp77XYj0Wx4",
        external: true
      }
    ]
  },
  {
    id: 21,
    date: {
      en: "09 Sep",
      sr: "09 Sep"
    },
    image: "/journal/community-most-wanted-drop-03.webp",
    title: {
      en: "You asked. We’re still listening.",
      sr: "Tražili ste. I dalje slušamo."
    },
    excerpt: {
      en: "Four more fragrances moved from the Community list into the PlayNice collection. And one of them, completely by chance, became fragrance number 100.",
      sr: "Četiri nova parfema prešla su sa Community liste u PlayNice kolekciju. A jedan od njih je, sasvim slučajno, postao naš parfem broj 100."
    },
    content: {
      en: `At first, it was just an idea.

We asked you what you wanted to see in the PlayNice collection. You started sending names. One vote, then another, then a few more. Some names disappeared quickly, while others stayed on the list for weeks. And then fragrances from the wishlist started moving into the collection.

First came YSL Y Iced and Valentino Coral Fantasy. Then Prada Paradigme and Bad Boy Cobalt. Back then, we wrote: Votes become collection.

It turns out that story was not finished. Since then, four more have arrived.

Lattafa Khamrah Waha — 13 votes.
Armaf Club de Nuit Intense Overdose — 12 votes.

With those two, the message was not exactly subtle. You asked for them often enough that, at some point, the only real question became: alright, when are we getting them? So we did.

But Community was never meant to be just a table where the fragrance at the top automatically wins. Which is why the next two may be even more interesting.

Tom Ford Ombré Leather Parfum — 6 votes.
Rayhaan Azul — 3 votes.

And both made it into the collection. Because the number of votes is a signal, but it is not the only one. Sometimes twenty people say the same thing. Sometimes three people mention a fragrance that makes so much sense for PlayNice that it becomes difficult to ignore.

And then something small happened with Tom Ford that we did not plan.

When Ombré Leather Parfum entered the Shop, it became our 100th fragrance. We did not choose fragrance number 100. We did not build a countdown. We did not decide in advance that it had to be some major name. It simply happened that a fragrance you asked for became number 100.

And it is hard to imagine a better way for that number to appear.

Because PlayNice was never supposed to be a collection built by one person behind closed doors. We search. We test. We choose. We reject far more fragrances than we accept. But you are part of that process. Community tells us where to look.

Today, there are eight fragrances on the right side of the Community page. Eight small pieces of proof that Request is not just a button and that something can actually happen behind a single vote. And on the left side, the list is growing again. Naxos is there. Torino21 too. Imagination is still refusing to give up.

We do not know which one will be next. And maybe that is the best part of the whole story.

Because Community Series was never about us telling you what you should want. It was about being able to say, every now and then: this is here because you said it should be.

You asked. We listened.

And apparently... we’re still listening.

— Charlie`,
      sr: `U početku je to bila samo ideja.

Pitali smo vas šta želite da vidite u PlayNice kolekciji. Vi ste počeli da šaljete imena. Jedan glas, pa drugi, pa još nekoliko. Neka imena su nestala brzo, neka su ostajala nedeljama. A onda su parfemi sa liste želja počeli da prelaze u kolekciju.

Prvo YSL Y Iced i Valentino Coral Fantasy. Zatim Prada Paradigme i Bad Boy Cobalt. Tada smo napisali: Glasovi postaju kolekcija.

Ispostavilo se da ta priča nije bila završena. Od tada su stigla još četiri.

Lattafa Khamrah Waha — 13 glasova.
Armaf Club de Nuit Intense Overdose — 12 glasova.

Za ova dva poruka nije bila naročito suptilna. Tražili ste ih dovoljno puta da je u jednom trenutku jedino pravo pitanje bilo: dobro, kada ih nabavljamo? I nabavili smo ih.

Ali Community nikada nije trebalo da bude samo tabela u kojoj prvi na listi automatski pobeđuje. Zato su nam možda još zanimljivija sledeća dva.

Tom Ford Ombré Leather Parfum — 6 glasova.
Rayhaan Azul — 3 glasa.

I oba su završila u kolekciji. Jer broj glasova jeste signal, ali nije jedini. Ponekad dvadeset ljudi kaže isto. Ponekad tri osobe pomenu parfem koji ima toliko smisla za PlayNice da ga više ne možete ignorisati.

A onda se sa Tom Fordom dogodila jedna mala stvar koju nismo planirali.

Kada je Ombré Leather Parfum ušao u Shop, postao je naš stoti parfem. Nismo birali parfem broj 100. Nismo pravili odbrojavanje. Nismo unapred odlučili da to mora biti neko veliko ime. Jednostavno se dogodilo da parfem koji ste vi tražili postane broj 100.

I teško je zamisliti bolji način da se ta brojka pojavi.

Jer PlayNice nikada nije trebalo da bude kolekcija koju jedna osoba sastavlja iza zatvorenih vrata. Mi tražimo. Probamo. Biramo. Odbijamo mnogo više parfema nego što ih prihvatimo. Ali vi ste deo tog procesa. Community nam govori gde da pogledamo.

Danas na desnoj strani Community stranice stoji osam parfema. Osam malih dokaza da Request nije samo dugme i da iza jednog glasa stvarno može da se dogodi nešto. Sa leve strane lista ponovo raste. Naxos je tamo. Torino21 takođe. Imagination se i dalje ne predaje.

Ne znamo koji će biti sledeći. I možda je upravo to najbolji deo cele priče.

Jer Community Series nikada nije bila priča o tome da mi vama kažemo šta treba da želite. Nego o tome da ponekad možemo da vam kažemo: ovo je ovde zato što ste vi rekli da treba da bude.

You asked. We listened.

And apparently... we’re still listening.

— Čarli`
    },
    series: {
      en: "COMMUNITY SERIES",
      sr: "SERIJA ZAJEDNICE"
    },
    relatedProducts: [
      "lattafa-khamrah-waha-edp",
      "armaf-club-de-nuit-intense-overdose",
      "tom-ford-ombre-leather-parfum",
      "rayhaan-azul-edp"
    ],
    links: [
      {
        label: {
          en: "Request the next fragrance",
          sr: "Predloži sledeći parfem"
        },
        action: "scent-request"
      }
    ]
  },
  {
    id: 22,
    date: {
      en: "9 Sep",
      sr: "9 Sep"
    },
    image: "/journal/article22.webp",
    title: {
      en: "Across from the Bakery",
      sr: "Preko puta pekare"
    },
    excerpt: {
      en: "For three months, he watched her from across the street. The only problem was that he had already written the entire story in his head.",
      sr: "Tri meseca je gledao preko puta pekare. Problem je bio samo u tome što je celu priču već napisao u svojoj glavi."
    },
    content: {
      en: `It's already Saturday, and I'm heading out to buy bread.

I don't look particularly good. I haven't slept enough, the T-shirt I'm wearing has probably survived more seasons than Fernando Alonso, my hair has developed its own political agenda, and the man outside the bakery is trying to start a Golf Mk2 that has clearly had enough of both life and its owner.

And I think: **This is beautiful.**

Nobody is filming. Nobody has put their phone on a tripod. Nobody is saying, *“Guys, a lot of you have been asking me...”*

Nobody asked you anything, Sandra. Just buy the bread.

Across from the bakery there's a small flower shop, and for a while now there's been a girl working there who has, entirely by accident, made me eat a lot more bread than I used to. I don't know her name. I only know that in the morning she carries the flowers outside, ties her hair back when it gets in the way, and has the kind of smile that makes a man forget, for a few seconds, his age, his bills, and the fact that his fridge is already full of bread.

Naturally, I've never spoken to her. I'm a modern man.

Which means I can spend months analysing the situation, look at her a few times, create seventeen possible scenarios in my head and, in the end, do absolutely nothing.

There was, however, one other problem.

Almost every weekend, I saw her with some guy.

Tall, handsome, well dressed, younger than me by exactly enough to make me dislike him immediately. He'd arrive, she'd come outside, hug him, sometimes they'd have coffee together, and I'd continue walking towards the bakery like a man who had just received an answer to a question he'd never asked.

And so it went on for weeks.

Then this Saturday, I'm standing there with a loaf of bread in my hand when I see him arrive. She walks out of the flower shop and hugs him, and then another girl gets out of the car.

She kisses him.

On the mouth.

Right.

This changes the table.

Five minutes later, the three of them are sitting together, laughing, while I, with a completely unjustified level of interest, buy a yoghurt I don't even need.

The woman behind the counter looks at me and says:

“That's her brother.”

There are moments in life when a man can suddenly see every bad decision he's ever made with perfect clarity.

This was one of them.

For months, I'd invented a boyfriend, a relationship, a happy couple, their future together and probably two children, simply because I hadn't had the courage to cross the street and say:

“Hi.”

And that's when it hits me how strange we've become.

We can message someone on the other side of the world, find out where they went last summer, what they listen to, what they eat and who they follow, but walking across the street and speaking to another human being suddenly feels like an extreme sport.

We know everything. We just don't dare do anything anymore.

Maybe that's why we're so hungry for good stories. Not perfect ones. Good ones. The kind where someone gets it wrong, looks stupid, arrives late, gets caught in the rain, says the wrong thing, laughs at themselves and tries anyway.

I don't need another perfect life on a screen.

I want a story.

And apparently, I'd been watching mine from across the street for the past three months.

I put the yoghurt down, crossed the street and walked into the flower shop.

What happened next?

Easy.

Not everything has to go online immediately.

—

**Charlie**

*Remember. PlayNice.*
`,
      sr: `## „Preko puta pekare“

Već je subota, izlazim po hleb.

Ne izgledam naročito dobro. Nisam se naspavao, majica koju nosim verovatno je već odradila više sezona nego Fernando Alonso, kosa vodi neku svoju politiku, a čovek ispred pekare pokušava da upali Golfa dvojku kojem je očigledno dosta i života i vlasnika.

I pomislim: **Kako je ovo lepo.**

Niko ne snima, niko nije stavio telefon na tripod, niko ne govori *„Guys, a lot of you have been asking me...”*

Niko te ništa nije pitao, Sandra. Samo kupi hleb.

Preko puta pekare je mala cvećara, a u njoj već neko vreme radi devojka zbog koje sam, sasvim slučajno, počeo mnogo češće da jedem hleb. Ne znam joj ime. Znam samo da ujutru iznosi cveće napolje, vezuje kosu kada joj smeta i ima onaj osmeh zbog kojeg čovek na nekoliko sekundi zaboravi i godine i račune i činjenicu da mu je frižider pun hleba.

Naravno da joj nikada nisam prišao. Ja sam moderan muškarac.

To znači da mogu mesecima da analiziram situaciju, pogledam je nekoliko puta, napravim u glavi sedamnaest mogućih scenarija i na kraju ne uradim ništa.

Postojao je, doduše, još jedan problem.

Gotovo svakog vikenda viđao sam je sa nekim tipom.

Visok, zgodan, uredan, mlađi od mene taman toliko da ga odmah ne volim. Dođe, ona izađe, zagrli ga, nekad zajedno popiju kafu i ja uredno nastavim prema pekari kao čovek koji je upravo dobio odgovor na pitanje koje nikada nije postavio.

I tako nedeljama.

A onda ove subote stojim sa hlebom u ruci i vidim njega kako dolazi. Ona izlazi iz cvećare, grli ga, a iz kola izlazi još jedna devojka. Poljubi ga.

U usta.

Dobro. Ovo već menja tabelu.

Pet minuta kasnije njih troje sede za stolom, smeju se, a ja sa potpuno neopravdanim interesovanjem kupujem jogurt koji mi uopšte ne treba.

Prodavačica me pogleda i kaže:

„To joj je brat.“

Postoje trenuci kada čovek u životu jasno vidi sve svoje pogrešne odluke.

Ovo je bio jedan od njih.

Mesecima sam izmislio momka, vezu, srećan par, njihovu zajedničku budućnost i verovatno dvoje dece, samo zato što nisam imao hrabrosti da pređem ulicu i kažem:

„Ćao.“

I tu mi sine koliko smo postali čudni.

Možemo da pošaljemo poruku nekome na drugom kraju sveta, da saznamo gde je bio prošlog leta, šta sluša, šta jede i koga prati, ali prići čoveku preko puta ulice odjednom izgleda kao ekstremni sport.

Sve znamo. Samo se više ništa ne usuđujemo.

Možda smo zato toliko željni lepih priča. Ne savršenih. Lepih. Onih u kojima neko pogreši, ispadne glup, zakasni, pokisne, kaže nešto pogrešno, nasmeje se sebi i ipak pokuša.

Ne treba mi još jedan savršen život na ekranu.

Hoću priču.

A izgleda da sam svoju već tri meseca gledao preko puta pekare.

Spustio sam jogurt, prešao ulicu i ušao u cvećaru.

Šta se dalje dogodilo?

Polako.

Ne mora baš sve odmah na internet.

—

**Čarli**

*Remember. PlayNice.*
`
    },
    relatedProducts: [
      "nishane-hacivat-x"
    ],
    links: [
    ]
  },
  {
    id: 23,
    date: {
      en: "25 Okt",
      sr: "25 Okt"
    },
    image: "/journal/article23.webp",
    title: {
      en: "Milica, It's Really Over.",
      sr: "Milice, stvarno je gotovo."
    },
    excerpt: {
      en: "Scientists are working on technology that could one day send smells through our phones. Fascinating, honestly — until you remember ex-girlfriends, angry neighbours and that friend you still owe twenty euros.",
      sr: "Naučnici rade na tehnologiji koja bi jednog dana mogla da nam šalje mirise preko telefona. Iskreno, to zvuči fascinantno — dok se ne setiš bivših devojaka, komšija i ljudi kojima duguješ dvadeset evra."
    },
    content: {
      en: `This morning I read that scientists are working on technology that would allow us to send smells over a distance. Like a photo, a message, or that cat video my friend has already sent me three times, even though I told him all three times that I had already seen it.

Smell through the phone.

I’m sitting there, drinking coffee, trying to imagine what that would look like in real life. Someone sends you a photo from the Maldives, you open the message, and suddenly your phone smells like the ocean. Wonderful. The only problem is that I already know enough people I would never trust with the power to send me anything that can be sensed with a nose.

And then there are ex-girlfriends.

Imagine getting a message at eleven at night: “Do you remember this smell?”

Yes, Milica, I remember. I remember the perfume and the credit I practically took out to buy it for you. I’m just asking you nicely not to start this all over again.

Milica, by the way, was a wonderful girl. She just had a remarkable talent for turning an ordinary question into an international incident. Once she asked whether I liked her new haircut, and I, completely unaware of the danger, said that I had also liked the previous one. The next three days of my life were spent explaining what I had actually meant, while she tried to determine whether I had ever truly loved a woman in my life.

Now imagine giving a person like that the ability to send smells.

First, her perfume would arrive, just to check whether I was still emotionally available. Then the smell of the restaurant where we had our first argument. Then the smell of my favourite jumper that she kept after the breakup. And once I finally gathered the courage not to answer, she would probably send me the smell of burnt lunch with a message saying, “There. That’s what our relationship smelled like.”

And Milica is not the only one who worries me.

I have a friend I’ve owed twenty euros to for six years. It’s not that I don’t want to pay him back. It’s just that we’ve both forgotten about it so many times that now it would almost feel rude to interrupt the tradition. He reminds me regularly, usually when we’re out with other people, and I can already picture him sending me the smell of fresh banknotes on the first of every month, and for my birthday, the smell of an empty wallet.

And what if you’ve seriously offended someone? Today an angry neighbour can leave you a passive-aggressive note or refuse to greet your wife in the lift. Tomorrow he’ll be able to send you the smell of his football shoes straight into your living room while you’re having dinner with guests. And how exactly do you explain to people that this isn’t your apartment, but an act of revenge by the man from the third floor whose parking spot you stole last summer?

Of course, the technology will probably come with some sort of protection. Blocking unwanted smells, parental controls, maybe even a premium subscription for better nostrils. Knowing the way apps work today, the free version will probably let you smell only half of the fragrance, while the base notes will require 9.99 a month.

But jokes aside, I have to admit that the whole idea fascinates me a little.

There are certain smells that can take me back twenty or thirty years in a second. The smell of petrol at an old gas station, freshly cut grass, the sea after summer rain, or some perfume I can’t seem to find anymore. All it takes is one accidental whiff and suddenly I remember people, places and moments I was certain had disappeared from my mind forever.

That’s why I understand why someone would want to build technology like this. It would be beautiful to send a friend who lives thousands of kilometres away the smell of the morning coffee you used to drink together. Or to send someone who hasn’t been home in years the smell of their own yard after the rain.

There is only one thing that scientists, no matter how clever they are, may never manage to fit into a phone.

They can send me the smell of the perfume Milica wore the night we met, but they cannot send me the moment she smiled, walked over to me and said something so unexpected that I forgot my own name.

That, apparently, is still a job for real life.

And while I’m thinking about all this, my phone rings.

Milica.

We haven’t spoken in almost two years.

I answer, slightly confused, and she asks if I’ve seen the news about sending smells through phones.

I say I have.

“Great,” she says. “Just so you know, when that thing starts working, I’ve got something for you.”

I ask her what.

“You’ll remember.”

And she hangs up.

So, dear scientists, I wish you every success with your work, but I kindly ask you not to rush this particular technology.

And if you absolutely must finish it, I have only one request.

Before accepting a smell, the phone should be required to ask: “Are you sure you want to go through this again?”

Because I, gentlemen, am not.

—

Charlie

Remember. PlayNice.`,
      sr: `Jutros sam pročitao da naučnici rade na tehnologiji koja će omogućiti da miris pošaljemo na daljinu. Kao fotografiju, poruku ili onaj video sa mačkom koji mi prijatelj šalje već treći put, iako sam mu sva tri puta rekao da sam ga video.

Miris preko telefona.

Sedim, pijem kafu i pokušavam da zamislim kako bi to izgledalo u praksi. Neko ti pošalje fotografiju sa Maldiva, ti otvoriš poruku, a iz telefona zamiriše okean. Divno. Samo što ja već poznajem dovoljno ljudi kojima nikada ne bih dao mogućnost da mi pošalju bilo šta što se može osetiti nosem.

A tek bivše devojke.

Zamisli da ti u jedanaest uveče stigne poruka: „Sećaš li se ovog mirisa?“

Sećam se, Milice. I parfema i kredita koji sam podigao da bih ga kupio. Samo te molim da ne počinjemo ponovo.

Milica je, inače, bila divna devojka, samo što je imala neobičan talenat da od običnog pitanja napravi međunarodni incident. Jednom me je pitala da li mi se sviđa njena nova frizura, a ja sam, potpuno nesvestan opasnosti, rekao da mi se sviđala i prethodna. Naredna tri dana proveo sam objašnjavajući šta sam zapravo mislio, dok je ona pokušavala da ustanovi da li sam ikada u životu zaista voleo neku ženu.

I sad zamislite da takvoj osobi date mogućnost da šalje mirise.

Prvo bi stigao njen parfem, čisto da proveri da li sam još emotivno dostupan. Zatim miris restorana u kojem smo se prvi put posvađali, pa miris mog omiljenog džempera koji je zadržala nakon raskida. A kad bih konačno skupio hrabrost da ne odgovorim, verovatno bi mi poslala miris zagorelog ručka uz poruku: „Eto, tako je izgledala naša veza.“

I nije Milica jedina koja me brine.

Imam prijatelja kojem već šest godina dugujem dvadeset evra. Nije da ne želim da mu vratim, nego smo obojica toliko puta zaboravili na taj dug da bi sada bilo neprijatno pokvariti tradiciju. Čovek me redovno podseća, uglavnom kada smo u društvu, i već mogu da zamislim kako mi svakog prvog u mesecu šalje miris novčanica, a za rođendan miris praznog novčanika.

A šta tek ako si se nekome ozbiljno zamerio? Danas ti ljut komšija može ostaviti neprijatnu poruku na vratima ili ti ne pozdraviti ženu u liftu. Sutra će moći da ti pošalje miris svojih patika posle fudbala, direktno u dnevnu sobu, dok večeraš sa gostima. I kako da objasniš ljudima da to nije tvoj stan, nego osveta čoveka sa trećeg sprata kojem si prošlog leta zauzeo parking?

Naravno, tehnologija će verovatno imati i neku zaštitu. Blokiranje neželjenih mirisa, roditeljsku kontrolu, možda čak i pretplatu za premium nosnice. Poznajući način na koji danas funkcionišu aplikacije, besplatna verzija će ti omogućavati da osetiš samo polovinu parfema, dok će za bazne note tražiti 9,99 evra mesečno.

Ali šalu na stranu, moram priznati da me cela ideja pomalo fascinira.

Postoje mirisi koji me u sekundi vrate dvadeset ili trideset godina unazad. Miris benzina na staroj pumpi, tek pokošene trave, mora posle letnje kiše ili nekog parfema koji više ne mogu nigde da pronađem. Dovoljno je da ih slučajno osetim i odjednom se setim ljudi, mesta i događaja za koje sam bio siguran da su zauvek nestali iz moje glave.

I zato razumem zašto neko želi da napravi takvu tehnologiju. Bilo bi lepo da prijatelju koji živi hiljadama kilometara daleko možeš da pošalješ miris jutarnje kafe koju ste nekada zajedno pili. Ili da nekome ko godinama nije bio kod kuće pošalješ miris njegovog dvorišta posle kiše.

Samo postoji jedna stvar koju naučnici, koliko god bili pametni, možda nikada neće uspeti da spakuju u telefon.

Mogu da mi pošalju miris parfema koji je Milica nosila one večeri kada smo se upoznali, ali ne mogu da mi pošalju onaj trenutak kada se nasmejala, prišla mi i rekla nešto toliko neočekivano da sam zaboravio kako se zovem.

To je, izgleda, i dalje posao za stvarni život.

I dok razmišljam o svemu tome, telefon mi zazvoni.

Milica.

Nismo se čuli skoro dve godine.

Javljam se, pomalo zbunjen, a ona me pita jesam li video vest o slanju mirisa preko telefona.

Kažem da jesam.

„E, super“, odgovara. „Samo da znaš, kad to proradi, imam nešto za tebe.“

Pitam je šta.

„Setićeš se.“

I prekine vezu.

Eto, dragi naučnici, želim vam mnogo uspeha u daljem radu, ali vas najljubaznije molim da sa tom tehnologijom ne žurite.

A ako baš morate da je završite, imam samo jedan zahtev.

Neka telefon, pre nego što prihvati miris, obavezno pita: „Da li ste sigurni da želite ponovo da prolazite kroz ovo?“

Jer ja, gospodo, nisam.

—

Čarli

Remember. PlayNice.`
    },
    relatedProducts: [
    ],
    links: [
      {
        label: {
          en: "Read the source",
          sr: "Pročitaj izvor"
        },
        url: "https://www.reuters.com/science/new-scentronic-technology-can-detect-transmit-aromas-remotely-2026-10-23/",
        external: true
      }
    ]
  }
];